export const strings = {
  "LIST_SEPARATOR": ", ",
  "LIST_SEPARATOR_SECONDARY": "; ",
  "TRUNCATED_TEXT_MORE_SEPARATOR": "...",
  "ABANDONED": "Abandoned",
  "ACCELERATOR": "Accelerator",
  "ACCELERATOR_ADMIN": "Accelerator Admin",
  "ACCELERATOR_CONSOLE": "Accelerator Console",
  "ACCELERATOR_ORGS_EMPTY_WARNING": "There are no Accelerator Organizations with Projects that are not assigned to a Participant. You can still create a Participant without a Project assignment.",
  "ACCELERATOR_ORGS_EXHAUSTED_WARNING": "There are no Accelerator Organizations remaining with Projects that are not assigned to a Participant.",
  "ACCELERATOR_ORGS_TOOLTIP": "Accelerator Organizations with Projects that are not assigned to a Participant",
  "ACCELERATOR_WELCOME_ALT": "Two people maintaining seedlings in a nursery",
  "ACCELERATOR_WELCOME_CONTENT": "Terraware will serve as your source of information for the Terraformation accelerator program. Review your To Do list below to see the tasks you need to review and complete before their due dates. See all of your tasks for the current phase by clicking Deliverables in the left menu.",
  "ACCELERATOR_WELCOME_HEADER": "Welcome to the Accelerator Program!",
  "ACCEPT": "Accept",
  "ACCEPTED": "Accepted",
  "ACCESSION": "Accession",
  "ACCESSION_BY_STATUS": "Accession by Status",
  "ACCESSION_DETAIL": "Accession Detail",
  "ACCESSION_DETAILS": "Accession Details",
  "ACCESSION_HISTORY": "Accession History",
  "ACCESSION_ID": "Accession ID",
  "ACCESSION_NUMBER_CHECKED_IN": "Accession {0} was successfully checked in!",
  "ACCESSIONS": "Accessions",
  "ACCESSIONS_CARD_DESCRIPTION": "Collect seeds and then record and view your accessions. Seed accessions can be viewed and analyzed by seed bank.",
  "ACCESSIONS_DATABASE_DESCRIPTION": "Manage your Accessions.",
  "ACCESSIONS_IMPORT_COMPLETE": "Accessions data import complete!",
  "ACCESSIONS_ONBOARDING_SEEDBANKS_MSG": "Define storage locations assigned to seed accessions",
  "ACCESSIONS_ONBOARDING_SPECIES_MSG": "Define a list of species used in your seed inventory",
  "ACCESSIONS_TO_BE_CHECKED_IN": "There are {0} accessions to check in.",
  "ACCOUNT": "Account",
  "ACHIEVED": "Achieved",
  "ACHIEVEMENTS": "Achievements",
  "ACTIVE_ACCESSIONS": "Active Accessions",
  "ACTUAL": "Actual",
  "AD_HOC": "Ad Hoc",
  "ADD": "Add",
  "ADD_A_NURSERY": "Add a Nursery",
  "ADD_A_PLANTING_SITE": "Add a Planting Site",
  "ADD_A_PLANTING_SITE_SUBTITLE": "Where do your plants take root? Set up your planting site so you can keep track of your plants’ progress.",
  "ADD_A_PROJECT": "Add a Project",
  "ADD_A_SEED_BANK": "Add a Seed Bank",
  "ADD_A_SPECIES": "Add a Species",
  "ADD_A_VIABILITY_TEST": "Add a Viability Test",
  "ADD_ADDRESS": "Add Address",
  "ADD_AN_ACCESSION": "Add an Accession",
  "ADD_BATCH": "Add Batch",
  "ADD_BOUNDARY": "Add Boundary",
  "ADD_COHORT": "Add Cohort",
  "ADD_DOCUMENT": "Add Document",
  "ADD_FUNDING_ENTITY": "Add Funding Entity",
  "ADD_GPS_COORDINATES": "Add GPS Coordinates",
  "ADD_INVENTORY": "Add Inventory",
  "ADD_INVENTORY_DESCRIPTION": "Add inventory from a new source. To add inventory from an existing seed accession, go to Accessions and withdraw from an accession entry.",
  "ADD_INVENTORY_MANUALLY_DESCRIPTION": "Enter species, quantities, and other relevant information using our inventory form.",
  "ADD_MANUALLY": "Add Manually",
  "ADD_METRIC": "Add Metric",
  "ADD_MODULE": "Add Module",
  "ADD_NEW_ORGANIZATION_FOOTNOTE": "You can edit this information later.",
  "ADD_NOTES": "Add Notes",
  "ADD_NURSERIES": "Add Nurseries",
  "ADD_NURSERY": "Add Nursery",
  "ADD_NURSERY_SUBTITLE": "How do you manage your seedlings? Set up your nursery so you can keep track of your seedlings’ growth.",
  "ADD_OBSERVATION": "Add Observation",
  "ADD_ORGANIZATION": "Add Organization",
  "ADD_PARTICIPANT": "Add Participant",
  "ADD_PEOPLE": "Add People",
  "ADD_PEOPLE_ONBOARDING_DESCRIPTION": "Invite people to your organization who will use Terraware. You can always add more people in Settings.",
  "ADD_PERSON": "Add Person",
  "ADD_PERSON_DESC": "Fill out this page to add a person to the organization.",
  "ADD_PERSON_GENERAL_DESC": "Enter the person’s information below.",
  "ADD_PHOTO": "Add Photo...",
  "ADD_PHOTOS": "Add Photos",
  "ADD_PHOTOS_DESCRIPTION": "Take a photo (or photos) of the batches that will be planted at the selected subzone. Be sure to include the entire withdrawal in the photo(s).",
  "ADD_PHOTOS_DESCRIPTION_OPTIONAL": "Take an optional photo (or photos) of the batches.",
  "ADD_PLANT_SITE_DESCRIPTION": "Add Plant and Site Description",
  "ADD_PLANTING_SITE": "Add Planting Site",
  "ADD_PLANTING_SITE_DETAILED_SITE": "Select if the site is relatively large, with multiple strata (vegetation layers) and growing conditions. Detailed planting sites with multiple strata will have one or more zones.",
  "ADD_PLANTING_SITE_SIMPLE_SITE": "Select if the planting site is relatively small, with a single stratum.",
  "ADD_PLANTING_SITE_TITLE": "Select Planting Site Type",
  "ADD_PROJECT": "Add Project",
  "ADD_PROJECT_BY_ORGANIZATION": "Add Project by Organization",
  "ADD_PROJECT_SUBTITLE": "Organize your data by projects.",
  "ADD_PROJECTS_BY_ORGANIZATION": "Add Project(s) by Organization",
  "ADD_PROPOSED_PROJECT_BOUNDARY": "Add Proposed Project Boundary",
  "ADD_QUANTITY": "Add Quantity",
  "ADD_SEED_BANK": "Add Seed Bank",
  "ADD_SEED_BANK_SUBTITLE": "How do you process and store your seeds? Set up your seed bank so you can keep track of where your seeds are stored.",
  "ADD_SEED_BANKS": "Add Seed Banks",
  "ADD_SPECIES": "Add Species",
  "ADD_SPECIES_MANUALLY_DESCRIPTION": "Enter scientific name and other optional fields manually, one species at a time.",
  "ADD_SPECIES_ONBOARDING_DESCRIPTION": "Manage species that your organization collects and plants.",
  "ADD_SPECIES_TO_PROJECT": "Add Species to Project",
  "ADD_SUB_LOCATION": "Add Sub-Location",
  "ADD_SUBSET_WEIGHT_AND_COUNT": "Add Subset Weight And Count",
  "ADD_TEST": "Add Test",
  "ADD_TO_PROJECT": "Add to Project",
  "ADD_VIABILITY": "Add Viability",
  "ADD_VIABILITY_TEST": "Add Viability Test",
  "ADDED": "Added",
  "ADDING_SUBZONE_BOUNDARIES": "Adding Subzone Boundaries",
  "ADDING_SUBZONE_BOUNDARIES_INSTRUCTIONS_DESCRIPTION": "This video shows how to use the slice {0} tool to create subzone shapes (polygons) within the zones.",
  "ADDING_ZONE_BOUNDARIES": "Adding Zone Boundaries",
  "ADDING_ZONE_BOUNDARIES_INSTRUCTIONS_DESCRIPTION": "This video shows how to use the slice {0} tool to create polygons within the site boundaries for zones.",
  "ADDITIONAL_INVASIVE_THREATENED_SPECIES": "Additional Invasive/Threatened Species",
  "ADDITIONAL_NURSERY_NOTES": "Additional Nursery Notes",
  "ADDITIONAL_OBSERVATIONS": "Additional Observations",
  "ADDITIONAL_PLANTING_SITES_NOTES": "Additional Planting Site Notes",
  "ADDITIONAL_RESOURCES": "Additional Resources",
  "ADDITIONAL_SPECIES_DATA": "Additional Species Data (Internal Use Only)",
  "ADMIN": "Admin",
  "ADMIN_INFO": "An admin can do the above as well as edit the organization profile, manage users in the organization, and manage seed banks.",
  "AGAR": "Agar",
  "AGAR_PETRI_DISH": "Agar Petri Dish",
  "AGE": "Age",
  "AGE_MONTHS": "Age (month)",
  "AGE_VALUE_1_MONTH": "1 Month",
  "AGE_VALUE_LESS_THAN_1_MONTH": "<1 Month",
  "AGE_VALUE_MONTHS": "{0} Months",
  "AGE_YEARS": "Age (yr)",
  "AGROFORESTRY": "Agroforestry",
  "ALL": "All",
  "ALL_ACCESSIONS_CHECKED_IN": "All accessions were successfully checked in!",
  "ALL_MODULES": "All Modules",
  "ALL_OBSERVATIONS": "All Observations",
  "ALL_SECTIONS": "All Sections",
  "ALL_SENSORS_FOUND": "All sensors found.",
  "ALL_VARIABLES": "All Variables",
  "ALREADY_INVITED_PERSON_ERROR": "It looks like you have already added or invited this person. Please enter a unique email address or go to the existing person’s profile.",
  "AMOUNT_EST_COUNT": "Amount (Est. Count)",
  "AMOUNT_REMAINING": "Amount ({0} remaining)",
  "ANIMAL_DAMAGE": "Animal Damage",
  "ANNUAL_CARBON_T": "Annual Carbon (t)",
  "ANNUAL_TARGET": "Annual Target",
  "ANSWER_APPROVED": "Answer Approved",
  "ANSWER_NOT_ACCEPETED": " Answer Not Accepted",
  "ANSWER_REJECTED": "Answer Rejected",
  "ANSWERS_NOT_ACCEPTED": "Answers Not Accepted",
  "ANSWERS_UPDATE_NEEDED": "Answers Update Needed",
  "APPLICATION": "Application",
  "APPLICATION_ERROR_NO_PROJECT_BOUNDARY": "Error: No project boundary drawn",
  "APPLICATION_FOR_PROJECT": "Application for {0}",
  "APPLICATION_INSTRUCTIONS": "Start by completing the Pre-screen. Then answer more in-depth questions about your project and upload any necessary documents in the Application. Each section of the Application will be available to view after your pre-screen has been approved.",
  "APPLICATION_INTERNAL_NAME": "Application Internal Name",
  "APPLICATION_LIST": "Application List",
  "APPLICATION_NOT_ACCEPTED": "Your Application has NOT been accepted.",
  "APPLICATION_NOT_ACCEPTED_BODY": "Your Application has NOT been accepted because the following criteria wasn’t met:",
  "APPLICATION_PRESCREEN": "Application Pre-screen",
  "APPLICATION_PRESCREEN_FAILURE_SUBTITLE": "Your Pre-screen is complete, but you do not qualify because the following criteria wasn’t met:",
  "APPLICATION_PRESCREEN_FAILURE_TITLE": "Your Pre-screen does NOT qualify.",
  "APPLICATION_PRESCREEN_SUCCESS_SUBTITLE": "Your Pre-screen is complete, and you qualify to proceed to the next step, Application.",
  "APPLICATION_PRESCREEN_SUCCESS_TITLE": "Success! Your Pre-screen qualifies.",
  "APPLICATION_RESTORABLE_LAND": "Application Restorable Land (ha)",
  "APPLICATION_STATUS": "Application Status",
  "APPLICATION_STEP_APPLICATION_DESCRIPTION": "For the full Accelerator Program Application, you will answer general questions about your project as well as forest restoration, community impact, financial and legal questions.",
  "APPLICATION_STEP_APPLICATION_NAME": "Application",
  "APPLICATION_STEP_DUEDILIGENCE_DESCRIPTION": "If your Application moves forward, we will request more documents from you about your project to confirm your proposed project’s eligibility.",
  "APPLICATION_STEP_DUEDILIGENCE_NAME": "Due Diligence",
  "APPLICATION_STEP_PRESCREEN_DESCRIPTION": "Draw your proposed project site map and complete the Pre-screen questions to determine if you qualify for our Accelerator Program.",
  "APPLICATION_STEP_PRESCREEN_NAME": "Pre-screen",
  "APPLICATION_SUBMIT_SUCCESS": "Success! Your Application has been submitted.",
  "APPLICATION_SUBMIT_SUCCESS_BODY": "Thank you for submitting an application to the Seed to Carbon Forest Accelerator. We have received your application and it is under review.\nYou can review your submitted responses and the status of your application in this account.",
  "APPLICATION_WAITLISTED": "Your Application has been Waitlisted.",
  "APPLICATION_WAITLISTED_BODY": "Your Application has been waitlisted because the following criteria wasn’t met:",
  "APPLICATIONS": "Applications",
  "APPLY": "Apply",
  "APPLY_RESULT": "Apply Result",
  "APPLY_RESULT_QUESTION": "Do you want to apply this result to the accession?",
  "APPLY_TO_ACCELERATOR": "Apply to Accelerator",
  "APPLY_TO_ACCELERATOR_DESCRIPTION": "Apply to our Seed to Carbon Forest Accelerator! Find out more {0} or click the button below to apply.",
  "APPROVE": "Approve",
  "APPROVE_DELIVERABLE": "Approve Deliverable",
  "APPROVED": "Approved",
  "APPROX_SYMBOL": "~",
  "ARE_YOU_SURE": "Are you sure?",
  "AREA_HA": "Area (ha)",
  "AS_OF_X": "as of {0}",
  "ASSIGN": "Assign",
  "ASSIGN_NEW_OWNER": "Assign New Owner",
  "ASSIGN_NEW_OWNER_DESC": "In order to remove the current owner, you must assign a new owner.",
  "ASSIGN_OWNER": "Assign Owner",
  "ASSIGN_OWNER_ELLIPSIS": "Assign Owner...",
  "ASSIGNED": "Assigned",
  "ATTACH_IMAGES_OR_VIDEOS": "Attach Image(s) or Video(s)",
  "ATTACHMENT_DESCRIPTION": "Attach up to {0} files. Each file has a maximum size of {1}MB.",
  "ATTACHMENT_LIMIT_REACHED": "Attachment Limit Reached",
  "ATTACHMENT_LIMIT_REACHED_MESSAGE": "You may only upload {0} attachments.",
  "ATTACHMENTS": "Attachments",
  "AVAILABLE": "available",
  "AVERAGE_WOOD_DENSITY": "Average Wood Density (kb/m3)",
  "AWAITING_CHECK_IN": "Awaiting Check-In",
  "AWAITING_PROCESSING": "Awaiting Processing",
  "BACK": "Back",
  "BACK_OF_SEED_BANK": "Back of Seed Bank",
  "BACK_TO_TERRAWARE": "Back to Terraware",
  "BAG_ID": "Bag ID",
  "BATCH": "Batch",
  "BATCH_DETAILS": "Batch Details",
  "BATCH_HISTORY_TYPE_DETAILS_EDITED": "Details Edited",
  "BATCH_HISTORY_TYPE_INCOMING_WITHDRAWAL": "Incoming Withdrawal",
  "BATCH_HISTORY_TYPE_OUTGOING_WITHDRAWAL": "Outgoing Withdrawal",
  "BATCH_HISTORY_TYPE_PHOTO_CREATED": "Photo Created",
  "BATCH_HISTORY_TYPE_PHOTO_DELETED": "Photo Deleted",
  "BATCH_HISTORY_TYPE_QUANTITY_EDITED": "Quantity Edited",
  "BATCH_HISTORY_TYPE_STATUS_CHANGED": "Status Changed",
  "BATCH_NUMBER": "Batch Number",
  "BATCH_WITHDRAW_SUCCESS": "{0} {1} for a total of {2} {3} withdrawn.",
  "BATCHES": "Batches",
  "BATCHES_AT": "Batches at {0}",
  "BATCHES_COLUMN_TOOLTIP": "Empty batches are not counted in this column.",
  "BATCHES_OF": "Batches of {0}",
  "BATCHES_PLURAL": "batches",
  "BATCHES_SINGULAR": "batch",
  "BEST_MONTHS_FOR_OBSERVATIONS": "Best Months for Observations",
  "BEST_MONTHS_FOR_OBSERVATIONS_INSTRUCTIONS": "These would be the seasons when it makes the most sense from the standpoint of your team’s capacity and also takes into account environmental factors such as the absence of snow and ability to easily identify planting survival. Please select all months that apply.",
  "BEST_MONTHS_FOR_OBSERVATIONS_VALIDATION_ERROR": "Please select at least one month.",
  "BIODIVERSITY": "Biodiversity",
  "BIOMASS_EMPTY_STATE_MESSAGE_1": "There are currently no ad hoc plot Observations.",
  "BIOMASS_EMPTY_STATE_MESSAGE_2": "Observations for Biomass Monitoring can be recorded through Ad Hoc Plot Observations in the mobile app.",
  "BIOMASS_MEASUREMENT": "Biomass Measurement",
  "BIOMASS_MEASUREMENTS": "Biomass Measurements",
  "BIOMASS_MONITORING": "Biomass Monitoring",
  "BOOLEAN_FALSE": "false",
  "BOOLEAN_TRUE": "true",
  "BOUNDARIES": "Boundaries",
  "BOUNDARIES_AND_ZONES": "Boundaries and Zones",
  "BUDGET_DOCUMENT_XLS": "Budget Document (.XLS)",
  "BUDGET_NARRATIVE_SUMMARY": "Budget Narrative Summary",
  "BUDGET_NARRATIVE_SUMMARY_INSTRUCTIONS": "Provide a high level narrative of your budget-to-actuals, noting any major discrepancies and listing any contributors. (One-half page maximum.)",
  "BUDGET_NARRATIVE_SUMMARY_REQUIRED": "Budget Narrative Summary *",
  "BUG_REPORT": "Bug Report",
  "BUG_REPORT_DESCRIPTION": "Let us know about an issue you encountered while using Terraware.",
  "BUG_REPORT_INSTRUCTIONS": "Provide a detailed description of the issue you encountered. (Where did the issue occur? What did you do before encountering the issue? What were you expecting to happen?)",
  "BY": "By",
  "BY_BATCH": "By Batch",
  "BY_NURSERY": "By Nursery",
  "BY_SPECIES": "By Species",
  "CANCEL": "Cancel",
  "CANCEL_DATA_CHECK": "Cancel Data Check",
  "CANNOT_EDIT": "Cannot Edit",
  "CANNOT_REMOVE": "Cannot Remove",
  "CANNOT_REMOVE_MSG": "You cannot remove yourself because there is no one else in the organization. Would you like to delete the organization instead?",
  "CANNOT_REMOVE_TF_CONTACT": "Terraformation contacts cannot be removed from an organization.",
  "CAPTION": "Caption",
  "CARBON": "Carbon",
  "CARBON_CAPACITY_TC02_HA": "Carbon Capacity (tCO2/ha)",
  "CARBON_ELIGIBILITY": "Carbon Eligibility",
  "CATALYTIC_CHECKBOX": "Terraformation’s support has been catalytic in securing additional funding or partnerships for our work.",
  "CATALYTIC_DETAIL": "Catalytic Funding",
  "CATALYTIC_DETAIL_INSTRUCTIONS": "Please state whether Terraformation’s support has been catalytic in securing additional funding or partnerships for your work. Provide detail where possible. (One-quarter page maximum.)",
  "CATEGORIES": "Categories",
  "CATEGORY": "Category",
  "CHALLENGE": "Challenge",
  "CHALLENGES": "Challenges and Setbacks",
  "CHALLENGES_AND_MITIGATION_PLAN": "Challenges and Mitigation Plan",
  "CHALLENGES_INSTRUCTIONS": "Terraformation believes that the learnings from challenges and failures are often where the greatest growth happens, and sharing these challenges can have a positive global benefit. Please list any challenges or setbacks you experienced during the reporting period. What is the impact of these challenges, and what are the ways in which these setbacks can be overcome in the current project? What would you want to do differently in a future project? (One page maximum.)",
  "CHALLENGES_REQUIRED": "Challenges and Setbacks *",
  "CHANGE": "Change",
  "CHANGE_DEFAULT_WEIGHT_SYSTEM": "You can change your default weight system from {0}",
  "CHANGE_GERMINATING_STATUS": "Change Germinating Status",
  "CHANGE_NOT_READY_STATUS": "Change Not Ready Status",
  "CHANGE_TO": "Change to {0}",
  "CHANGES": "Changes",
  "CHANGES_SAVED": "Changes Saved!",
  "CHECK_DATA": "Check Data",
  "CHECK_DATA_DESCRIPTION": "You can run a database check to compare your species information with what’s stored in the GBIF Database. This will flag entries if the scientific name of your species is spelled wrong, or is missing from the database. This could take a few minutes, and you can’t cancel it once it starts.",
  "CHECK_DATE": "Check Date",
  "CHECK_DATE_REQUIRED": "Check Date *",
  "CHECK_IN": "Check In",
  "CHECK_IN_ALL": "Check In All",
  "CHECK_IN_ALL_CONFIRM": "Are you sure you want to check in all accessions? This action cannot be undone.",
  "CHECK_IN_MESSAGE": "{0} new accessions should have been dropped off at the seed bank. Please verify their arrival and check them in.",
  "CHECK_THAT_ALL_REQUIRED_QUESTIONS_ARE_FILLED_OUT_BEFORE_SUBMITTING": "Check that all required questions are filled out before submitting",
  "CHECKED_IN": "Checked In!",
  "CHECKIN_ACCESSIONS": "Check In Accessions",
  "CHECKING_DATA": "Running database check. Please wait, this may take a few minutes...",
  "CHEMICAL": "Chemical",
  "CHOOSE_FILE": "Choose File...",
  "CITATION": "Citation",
  "CITY": "City",
  "CLAIMED": "Claimed",
  "CLIMATE": "Climate",
  "CLIMATE_IMPACT": "Climate Impact",
  "CLOSE": "Close",
  "COHORT": "Cohort",
  "COHORT_ADDED": "{0} Cohort added",
  "COHORT_NAME": "Cohort Name",
  "COHORT_PHASE_DUE_DILIGENCE": "Phase 0 - Due Diligence",
  "COHORT_PHASE_FEASIBILITY_STUDY": "Phase 1 - Feasibility Study",
  "COHORT_PHASE_IMPLEMENT_AND_MONITOR": "Phase 3 - Implement and Monitor",
  "COHORT_PHASE_PLAN_AND_SCALE": "Phase 2 - Plan and Scale",
  "COHORTS": "Cohorts",
  "COHORTS_AND_PROJECTS": "Cohorts and Projects",
  "COHORTS_AND_PROJECTS_DESCRIPTION": "Below are a list of Cohorts and their Projects that have added this module.",
  "COHORTS_EMPTY_STATE": "You have no cohorts yet. When you add cohorts you will see them here.",
  "COLLECTED_DATE": "Collected Date",
  "COLLECTED_FROM": "Collected from",
  "COLLECTING_SITE": "Collecting Site",
  "COLLECTION_DATE": "Collection Date",
  "COLLECTION_DATE_REQUIRED": "Collection Date *",
  "COLLECTION_SITE": "Collection Site Name",
  "COLLECTION_SOURCE": "Plant Source Type",
  "COLLECTOR": "Collector",
  "COLLECTORS": "Collectors",
  "COMMENTS": "Comments",
  "COMMON_NAME": "Common Name",
  "COMMUNITY": "Community",
  "COMPLETE": "Complete",
  "COMPLETE_REPORTS": "Complete Reports",
  "COMPLETE_REPORTS_SUBTITLE": "Your reports are ready to be completed and submitted to Terraformation:",
  "COMPLETED": "Completed",
  "COMPLETED_ENDED": "Completed (Ended)",
  "COMPLIANCE": "Compliance",
  "COMPONENT": "Component",
  "CONDITIONAL": "Conditional",
  "CONFIRMED_RESTORABLE_LAND": "TF Restorable Land (ha)",
  "CONNECT_FAILED": "Connect failed",
  "CONNECTED": "Connected",
  "CONSERVATION_CATEGORY": "IUCN Red List Category",
  "CONTACT_US": "Contact Us",
  "CONTACT_US_DESCRIPTION": "Let us know about your experience with Terraware and inquire about additional support for you or your organization.",
  "CONTACT_US_INSTRUCTIONS": "Your feedback is very important to us. Please let us know about your experience with Terraware and how we can help you and your organization get the most out of Terraware.",
  "CONTENT_AND_MATERIALS": "Content and Materials",
  "CONTENTS": "Contents",
  "CONTINUE_AND_RESET_STATUS": "Continue and Reset Status",
  "CONTINUE_APPLICATION": "Continue Application",
  "CONTINUE_TO_APPLICATION": "Continue to Application",
  "CONTRIBUTOR": "Contributor",
  "CONTRIBUTOR_INFO": "A contributor can add data entries for seeds, manage nursery inventory except planting withdrawals, view withdrawals, manage nursery reassignments and visualize a planting site’s plantings on a geographical map.",
  "CONVERTED_VALUE_INFO": "This value is auto-calculated for informational purposes.",
  "COOKIES": "Cookies",
  "COOKIES_ACCEPT": "Accept Cookies",
  "COOKIES_DECLINE": "Decline Cookies",
  "COOKIES_DESCRIPTION": "Terraware uses performance cookies to analyze and improve the quality of the site and enhance your user experience.",
  "COOKIES_LEARN_MORE": "Learn more about our cookie policy.",
  "COUNT": "Count",
  "COUNTRY": "Country",
  "COUNTRY_REQUIRED": "Country *",
  "CREATE": "Create",
  "CREATE_NEW_ORGANIZATION": "Create New Organization",
  "CREATE_NEW_PROJECT": "Create New Project",
  "CREATE_ORGANIZATION": "Create Organization",
  "CREATE_ORGANIZATION_QUESTION_LOCATION_TYPES": "Does your organization manage any of the following? Check all that apply.",
  "CREATE_ORGANIZATION_QUESTION_ORGANIZATION_TYPE": "Which of the following best describes your organization?",
  "CREATE_SPECIES_LIST": "Create Species List",
  "CREATED": "Created",
  "CREATED_BY": "Created by",
  "CREATED_ON": "Created on",
  "CROWN_DIAMETER_CM": "Crown Diameter (cm)",
  "CSV_FILE": "CSV file",
  "CT": "ct",
  "CULTIVATED": "Cultivated",
  "CULTIVATED_EX_SITU": "Cultivated (Ex Situ)",
  "CULTIVATED_EX_SITU_DESCRIPTION": "Plants that have been grown in a nursery, seed production area, or other propagation facility.",
  "CURRENT_NEXT_OBSERVATION": "Current/Next Observation",
  "CURRENT_PHASE": "Current Phase",
  "CURRENT_TIMELINE": "Current Timeline",
  "CUSTOMIZE_COLUMNS": "Customize Columns...",
  "CUSTOMIZE_TABLE_COLUMNS": "Customize table columns",
  "CUSTOMIZE_TABLE_COLUMNS_DESCRIPTION": "Select columns you want to add. Deselect columns you want to remove.",
  "CUT_TEST": "Cut Test",
  "DASHBOARD": "Dashboard",
  "DASHBOARD_HEADER_TEXT": "The data on this dashboard is based on a sample of {0} hectares from the {1} observation.",
  "DASHBOARD_HEADER_TEXT_SINGLE_OBSERVATION": "Observation data on this dashboard is based on a sample of {0} from the {1} for this planting site.",
  "DASHBOARD_HEADER_TEXT_V2": "Observation data on this dashboard is based on a sample of {0} from observations between {1} through {2}.",
  "DASHBOARD_MESSAGE": "Your seeds dashboard will automatically populate with data as you add accessions.",
  "DASHBOARD_MESSAGE_TITLE": "Add Accessions to See Data",
  "DATA_CHECK_COMPLETED": "Database check complete. No errors were found!",
  "DATA_CHECK_WITH_PROBLEMS": "Database check complete. {0} potential errors were found.",
  "DATA_IMPORT_FAILED": "Data import failed",
  "DATA_IMPORT_ROW_MESSAGE": "Row {0}: {1}",
  "DATE": "Date",
  "DATE_ADDED": "Date Added",
  "DATE_ADDED_REQUIRED": "Date Added *",
  "DATE_MUST_BE_FUTURE": "Date must be in the future",
  "DATE_OBSERVATION": "{0} Observation",
  "DATE_OF_LAST_OBSERVATION": "Date of Last Observation",
  "DATE_RANGE": "{0} - {1}",
  "DATE_SUBMITTED": "Date Submitted",
  "DATE_UPDATED": "Date Updated",
  "DATE_UPLOADED": "Date Uploaded",
  "DBH_CM": "DBH (cm)",
  "DEAD": "Dead",
  "DEAD_PLANTS_OBSERVED": "Dead Plants Observed",
  "DEAL_DESCRIPTION": "Deal Description",
  "DEAL_NAME": "Deal Name",
  "DECLINE": "Decline",
  "DEFAULT_LANGUAGE_SELECTED": "Default language: {0}",
  "DEGREES_CELSIUS_VALUE": "{0}ºC",
  "DELETE": "Delete",
  "DELETE_ACCESSION": "Delete Accession",
  "DELETE_ACCESSION_MESSAGE": "You’re about to delete accession {0}.",
  "DELETE_ACCOUNT": "Delete Account",
  "DELETE_ACCOUNT_CONFIRMATION": "Are you sure you want to delete your account? This cannot be undone.",
  "DELETE_ACCOUNT_ERROR": "There was an error deleting your account.",
  "DELETE_CONFIRMATION_MODAL_MAIN_TEXT": "Are you sure you want to delete the unused selected species?",
  "DELETE_FUNDING_ENTITY": "Delete Funding Entity",
  "DELETE_FUNDING_ENTITY_FUNDERS_MESSAGE": "All Funders associated with this Funding Entity will be deleted.",
  "DELETE_FUNDING_ENTITY_MESSAGE": "You’re about to delete {0}.",
  "DELETE_ORGANIZATION": "Delete Organization",
  "DELETE_ORGANIZATION_MSG": "Are you sure you want to delete {0}?",
  "DELETE_PLANTING_SITE": "Delete Planting Site",
  "DELETE_PLANTING_SITE_CONTACT_US": "Please [contact us] to delete the planting site.",
  "DELETE_PLANTING_SITE_IN_USE_MESSAGE": "Planting site {0} has plantings allocated.",
  "DELETE_PLANTING_SITE_MESSAGE": "You’re about to delete planting site {0}.",
  "DELETE_PROJECT": "Delete Project",
  "DELETE_PROJECT_CONFIRM": "Are you sure you want to delete this project? All project categorization will be removed.",
  "DELETE_SEEDLINGS_BATCHES": "Delete Seedlings Batches",
  "DELETE_SEEDLINGS_BATCHES_MSG": "Are you sure you want to delete the seedlings batches?",
  "DELETE_SPECIES": "Delete Species",
  "DELETE_STATISTICS": "Delete Statistics",
  "DELETE_VIABILITY_TEST": "Delete Viability Test",
  "DELETE_VIABILITY_TEST_MESSAGE": "You’re about to delete viability test {0}.",
  "DELETED_SPECIES": "<deleted species>",
  "DELIVERABLE_APPROVED": "Deliverable Approved",
  "DELIVERABLE_CATEGORY": "Category: {0}",
  "DELIVERABLE_ID": "Deliverable ID",
  "DELIVERABLE_NAME": "Deliverable Name",
  "DELIVERABLE_NOT_ACCEPTED": "Deliverable Not Accepted",
  "DELIVERABLE_PROJECT": "Project: {0}",
  "DELIVERABLE_REJECTED": "Deliverable Rejected",
  "DELIVERABLE_STATUS_CHANGE_CONFIRMATION_1": "Submitting a document after a deliverable has been reviewed will reset the deliverable status.",
  "DELIVERABLE_STATUS_CHANGE_CONFIRMATION_2": "Are you sure you still want to submit a document?",
  "DELIVERABLE_STATUS_UPDATED": "Deliverable Status Updated",
  "DELIVERABLE_SUBMITTED": "Deliverable Submitted",
  "DELIVERABLE_SUBMITTED_FOR_APPROVAL": "Deliverable Submitted for Approval",
  "DELIVERABLE_UPDATE_NEEDED": "Deliverable Update Needed",
  "DELIVERABLE_UPDATE_REQUESTED": "Deliverable Update Requested",
  "DELIVERABLES": "Deliverables",
  "DELIVERABLES_IMPORT_COMPLETE": "Deliverables data import complete!",
  "DENSITY_COMFORTABLE": "Density - Comfortable",
  "DENSITY_COMPACT": "Density - Compact",
  "DENSITY_ROOMY": "Density - Roomy",
  "DENSITY_SETTINGS": "Density Settings",
  "DESCRIBE_ORGANIZATION_TYPE_DETAILS": "Describe your organization",
  "DESCRIPTION": "Description",
  "DESCRIPTION_KNOWLEDGE_BASE": "Learn how to use Terraware and find answers to your questions about Terraware features.",
  "DESCRIPTION_KNOWLEDGE_BASE_WITH_LINK": "Learn how to use Terraware and find answers to your questions about Terraware features in the {0}.",
  "DESCRIPTION_NOTES": "Description/Notes",
  "DESCRIPTION_ORGANIZATION": "Your organization may include people, and species.",
  "DESCRIPTION_PEOPLE": "Invite those who contribute to the organization’s success.",
  "DESCRIPTION_REPORT_PROBLEM": "If you’re experiencing an issue while using Terraware, please let us know. Please mention this build version: {0}.",
  "DESCRIPTION_REQUEST_FEATURE": "We’re always interested in improving your experience with Terraware. Let us know how we can help you make the most out of it.",
  "DESCRIPTION_REQUIRED": "Description *",
  "DESCRIPTION_SPECIES": "Manage species that you collect or plant.",
  "DESTINATION": "Destination",
  "DESTINATION_REQUIRED": "Destination *",
  "DETAILED_SITE": "Detailed Site",
  "DETAILS": "Details",
  "DEV_SERVER_ERROR": "Server unavailable (may be restarting with new code changes). Reload?",
  "DIAMETER_AT_BREAST_HEIGHT": "Diameter at Breast Height (DBH) at Maturity (cm)",
  "DIAMETER_CM": "Diameter (cm)",
  "DIRECTION_OR_DESCRIPTION": "Direction or Description",
  "DISMISS": "Dismiss",
  "DOC_PRODUCER": "Doc Producer",
  "DOCUMENT": "Document",
  "DOCUMENT_DETAILS": "Edit Document Details",
  "DOCUMENT_LIMIT_REACHED": "Document Limit Reached",
  "DOCUMENT_LIMIT_REACHED_MESSAGE": "You may only upload {0} documents. Talk to your Terraformation representative if you would like to upload more.",
  "DOCUMENT_NAME": "Document Name",
  "DOCUMENT_OWNER": "Document Owner",
  "DOCUMENT_STATUS": "Document Status",
  "DOCUMENT_TEMPLATE": "Document Template",
  "DOCUMENTS": "Documents",
  "DOCUMENTS_ADD_CARD_INSTRUCTIONS": "You have no documents yet. Start by adding one below.",
  "DOCUMENTS_ADD_CARD_TITLE": "Add a Document",
  "DOCUMENTS_ADD_FORM_ASSOC_ORG": "Associated Organization",
  "DOCUMENTS_ADD_FORM_DOC_NAME": "Document Name",
  "DOCUMENTS_ADD_FORM_DOC_OWNER": "Document Owner",
  "DOCUMENTS_ADD_FORM_DOCUMENT_TEMPLATE": "Document Template",
  "DOCUMENTS_ADD_FORM_METHODOLOGY": "Methodology",
  "DONE": "Done",
  "DONT_SHOW_AGAIN": "Don't Show Again",
  "DOWNLOAD": "Download",
  "DOWNLOAD_COMPLETE": "Download complete",
  "DOWNLOAD_CSV_TEMPLATE": "Download a CSV template here.",
  "DOWNLOAD_FAILED": "Download failed",
  "DOWNLOAD_FAILED_DESCRIPTION": "The download has failed. Please email {0} so we can assist you.",
  "DOWNLOAD_FOR_ANDROID": "Download for Android",
  "DOWNLOAD_FOR_IOS": "Download for iOS",
  "DOWNLOAD_IN_PROGRESS": "Download in progress...",
  "DOWNLOAD_ON_APP_STORE": "Download on the App Store",
  "DOWNLOAD_ON_GOOGLE_PLAY": "Get it on Google Play",
  "DOWNLOAD_REPORT_DESCRIPTION": "You are about to download this table as a spreadsheet (CSV file). Name your spreadsheet below.",
  "DOWNLOAD_SPECIES_SUBMISSION_SNAPSHOT": "Download List (.csv) at Time of Approval",
  "DOWNLOAD_TEMPLATE": "Download a template here.",
  "DOWNLOAD_THE_CSV_TEMPLATE": "Download the CSV template.",
  "DOWNLOAD_THE_TERRAWARE_MOBILE_APP": "Download the Terraware Mobile App",
  "DOWNLOAD_THE_TERRAWARE_MOBILE_APP_DESCRIPTION": "Get the mobile app to take advantage of Seed Collection, Nursery Management, and Plant Monitoring features you can use with more flexibility beyond your desktop!",
  "DRAFT": "Draft",
  "DRAW_BOUNDARY_WITHIN_MAP": "Draw the boundary within a map",
  "DRAW_PROJECT_BOUNDARY": "Draw the Project Boundary",
  "DRAW_PROPOSED_PROJECT_BOUNDARY": "Draw Proposed Project Boundary",
  "DROPBOX_FOLDER_URL": "Dropbox Folder URL",
  "DRY_CABINET": "Dry Cabinet",
  "DRYING": "Drying",
  "DRYING_RACKS": "Drying Racks",
  "DUE": "Due: {0}",
  "DUE_DATE": "Due date",
  "DUE_DATE_PREFIX": " Due Date: {0}",
  "DUPLICATE_SPECIES_FOUND": "Duplicate species found.",
  "DUPLICATED_ACCESSION_NUMBER": "We found {0} duplicated accession numbers:",
  "DUPLICATED_INVENTORY": "We found {0} duplicated inventory:",
  "DUPLICATED_SPECIES": "We found {0} duplicated species:",
  "ECOLOGICAL_ROLE_KNOWN": "Ecological Role Known",
  "ECOLOGICAL_ROLE_KNOWN_TOOLTIP": "List ecological roles such as functional group of the species, ecosystem services provided, role as keystone species, etc.",
  "ECOSYSTEM_BOREAL_FOREST_TAIGA": "Boreal forests/Taiga",
  "ECOSYSTEM_DESERT_XERIC_SHRUBLAND": "Deserts and xeric shrublands",
  "ECOSYSTEM_FLOODED_GRASSLAND_SAVANNA": "Pastizal y sabana inundados",
  "ECOSYSTEM_MANGROVE": "Mangroves",
  "ECOSYSTEM_MEDITERRANEAN_FOREST": "Mediterranean forests, woodlands and scrubs",
  "ECOSYSTEM_MONTANE_GRASSLAND_SHRUBLAND": "Montane grasslands and shrublands",
  "ECOSYSTEM_TEMPERATE_BROADLEAF_MIXED_FOREST": "Temperate broad leaf and mixed forests",
  "ECOSYSTEM_TEMPERATE_CONIFEROUS_FOREST": "Temperate coniferous forest",
  "ECOSYSTEM_TEMPERATE_GRASSLAND_SAVANNA_SHRUBLAND": "Temperate grasslands, savannas and shrublands",
  "ECOSYSTEM_TROPICAL_CONIFEROUS_FOREST": "Tropical and subtropical coniferous forests",
  "ECOSYSTEM_TROPICAL_DRY_BROADLEAF_FOREST": "Tropical and subtropical dry broad leaf forests",
  "ECOSYSTEM_TROPICAL_GRASSLAND_SAVANNA_SHRUBLAND": "Tropical and subtropical grasslands, savannas and shrublands",
  "ECOSYSTEM_TROPICAL_MOIST_BROADLEAF_FOREST": "Tropical and subtropical moist broad leaf forests",
  "ECOSYSTEM_TUNDRA": "Tundra",
  "ECOSYSTEM_TYPE": "Ecosystem Type",
  "EDIT": "Edit",
  "EDIT_ACCESSION": "Edit Accession",
  "EDIT_ACCESSION_DETAIL": "Edit Accession Detail",
  "EDIT_ACCOUNT": "Edit Account",
  "EDIT_BATCH_DETAILS": "Edit Batch Details",
  "EDIT_COHORT": "Edit Cohort",
  "EDIT_COHORT_TO_ADD_MODULES": "Edit this cohort to add modules.",
  "EDIT_DOCUMENT_DETAILS": "Edit Document Details",
  "EDIT_FEEDBACK": "Edit Feedback",
  "EDIT_FUNDING_ENTITY": "Edit Funding Entity",
  "EDIT_FUNDING_ENTITY_DESC": "Edit the Funding Entity and associated projects",
  "EDIT_LOCATION": "Edit Location",
  "EDIT_NURSERY": "Edit Nursery",
  "EDIT_ORGANIZATION": "Edit Organization",
  "EDIT_PARTICIPANT": "Edit Participant",
  "EDIT_PERSON": "Edit Person",
  "EDIT_PLANTING_SITE": "Edit Planting Site",
  "EDIT_PROJECT": "Edit Project",
  "EDIT_PROJECT_NAME": "Edit Project Name",
  "EDIT_PROJECT_NAME_CONFIRMATION": "You are editing a project name that is currently being used by {0} in Terraware.",
  "EDIT_QUANTITY": "Edit Quantity",
  "EDIT_QUANTITY_DISABLED": "Quantity may not be edited when the status is \"Used Up\".",
  "EDIT_SCORES": "Edit Scores",
  "EDIT_SEED_BANK": "Edit Seed Bank",
  "EDIT_SETTINGS": "Edit Settings",
  "EDIT_SPECIES": "Edit Species",
  "EDIT_STATUS": "Edit Status",
  "EDIT_VIABILITY": "Edit Viability",
  "EDIT_VIABILITY_TEST": "Edit Viability Test",
  "EDIT_VOTES": "Edit Votes",
  "EDITABLE_TABLE_ADD_ROW": "Add Row",
  "EDITABLE_TABLE_ADD_TABLE": "Add Table",
  "EDITABLE_TABLE_REMOVE_TABLE": "Remove Table",
  "EDITED_BY": "Edited By",
  "EDITING_SPECIES_DATA_FOR_ORGANIZATION": "Editing Species Data for {0}",
  "EDITING_SPECIES_DATA_FOR_ORGANIZATION_WARNING": "You are editing species data for {0}. Any changes you make here will be reflected in their database immediately.",
  "ELEVATION": "Elevation",
  "ELEVATION_M": "Elevation (m)",
  "ELIGIBLE_AREA": "Eligible Area",
  "EMAIL": "Email",
  "EMAIL_ALREADY_EXISTS": "This email already exists.",
  "EMAIL_REQUIRED": "Email *",
  "EMAIL_REQUIREMENT_TERRAFORMATION": "Email address must include @terraformation.com",
  "EMPTY_BATCH": "Empty Batch",
  "EMPTY_BATCHES_AFTER_WITHDRAW": "One or more batches are now empty and will not appear in the batch tables. To see empty batches, click on the table filter and check \"Show Empty Batches.\"",
  "END": "End",
  "END_DATE": "End Date",
  "END_DRYING_REMINDER": "End-Drying Reminder",
  "END_DRYING_REMINDER_OFF": "End-drying Reminder Off",
  "END_OBSERVATION": "End Observation",
  "END_OBSERVATION_MODAL_MESSAGE": "Ending an observation when there are no observed or partially observed plots will result in skewed summary data.",
  "END_OBSERVATION_MODAL_QUESTION": "Are you sure you want to end the {0} observation early?",
  "END_TIME": "End Time",
  "ENDANGERED": "Endangered",
  "ENTER_LOCATION": "Enter Location",
  "ENTER_SIX_DIGIT_KEY": "Enter 6-digit key",
  "ENTER_SUBSET_WEIGHT_AND_COUNT": "Enter Subset Weight and Count ratio to determine approximate seed count when withdrawing by weight from a count quantity. (Conversely, the ratio will determine approximate remaining quantity when withdrawing by count from a weight quantity.) These fields are useful when counting tiny seeds is not practical and only required if you intend to withdraw from this accession to a nursery.",
  "ENTRIES": "Entries",
  "ERROR": " Error",
  "ERROR_BATCH_SEED_COUNT": "Transfers must include at least 1 seed",
  "ERROR_CREATE_APPLICATION": "Unable to create new application",
  "ERROR_CREATE_PROJECT": "Unable to create new project",
  "ERROR_LOAD_SPECIES": "Unable to load species for the organization",
  "ERROR_LOAD_SUB_LOCATIONS": "Unable to load sub locations for facility",
  "ERROR_PROJECT_NAME_CONFLICT": "This project name is already in use in the organization.",
  "ERROR_PROJECT_SELECT": "This project is not eligible to be selected.",
  "ERROR_SUPPORT_NOTIFIED": "An error occurred: Our support team has been notified and is working on fixing the issue.",
  "EST_READY_DATE": "Est. Ready Date",
  "EST_TOTAL_PLANTS_PLANTING_DENSITY_AREA": "Est. Total Plants (Planting Density × Area)",
  "ESTIMATED_READY_DATE": "Estimated Ready Date",
  "EVENT": "Event",
  "EVENT_CALL_DESCRIPTION_1": "Clicking \"{0}\" will open up a browser window to join a Google Meet video call.",
  "EVENT_CALL_DESCRIPTION_2": "For this {0} you will need:",
  "EVENT_CALL_REQUIREMENTS_INTERNET": "An internet connection on your device - broadband wired or wireless (3G or 4G/LTE)",
  "EVENT_CALL_REQUIREMENTS_SPEAKERS_MIC": "Speakers and a microphone – built-in, USB plug-in, or wireless Bluetooth",
  "EVENT_CALL_REQUIREMENTS_WEBCAM": "A webcam or HD webcam - built-in, USB plug-in",
  "EVENT_DETAILS": "Event Details",
  "EVENT_NAME_RECORDING": "{0} Recording",
  "EVENT_NAME_SLIDES": "{0} Slides",
  "EVENT_RECORDED_SESSION_DESCRIPTION_1": "Watch this Recorded Session at any time. You can watch the session more than once, as needed.",
  "EVENT_RECORDED_SESSION_REQUIREMENTS_SPEAKERS": "Speakers or headset - built-in, USB plug-in, or wireless Bluetooth",
  "EVENTS": "Events",
  "EXCLUSION_AREAS": "Exclusion Areas",
  "EXISTING_PROJECT_ACCESSIONS_BODY": "There are accessions that have already been added to an existing project. If you select those accessions here, you will replace the project with {0} (rather than create an additional association).",
  "EXISTING_PROJECT_ACCESSIONS_TITLE": "Existing Project with Accessions",
  "EXISTING_PROJECT_BATCHES_BODY": "There are batches that have already been added to an existing project. If you select those batches here, you will replace the project with {0} (rather than create an additional association).",
  "EXISTING_PROJECT_BATCHES_TITLE": "Existing Project with Batches",
  "EXISTING_PROJECT_PLANTING_SITES_BODY": "There are planting sites that have already been added to an existing project. If you select those planting sites here, you will replace the project with {0} (rather than create an additional association).",
  "EXISTING_PROJECT_PLANTING_SITES_TITLE": "Existing Project with Planting Sites",
  "EXISTING_SPECIES_MSG": "“{0}” is already in your species list.",
  "EXIT_APPLICATION": "Exit Application",
  "EXPANSION_POTENTIAL": "Expansion Potential",
  "EXPERIENCE_AND_UNDERSTANDING": "Experience and Understanding",
  "EXPORT": "Export",
  "EXPORT_BIOMASS_MONITORING_DETAILS_CSV": "Export Biomass Monitoring Details (CSV)",
  "EXPORT_LOCATIONS": "Export Locations",
  "EXPORT_LOCATIONS_DISABLED_TOOLTIP": "Plot locations are determined at the start of the observation",
  "EXPORT_PROJECT_BOUNDARY": "Export Project Boundary",
  "EXPORT_RECORDS": "Export Records",
  "EXPORT_SPECIES_CSV": "Export Species (CSV)",
  "EXPORT_TREES_AND_SHRUBS_CSV": "Export Trees and Shrubs (CSV)",
  "FACILITY": "Facility",
  "FACILITY_BUILD_COMPLETION_DATE": "Build Completion Date",
  "FACILITY_BUILD_COMPLETION_DATE_INVALID": "Must be between build start and operation start dates.",
  "FACILITY_BUILD_COMPLETION_DATE_REQUIRED": "Build Completion Date *",
  "FACILITY_BUILD_START_DATE": "Build Start Date",
  "FACILITY_BUILD_START_DATE_INVALID": "Must be on or before build completed date and operation start dates.",
  "FACILITY_BUILD_START_DATE_REQUIRED": "Build Start Date *",
  "FACILITY_OPERATION_START_DATE": "Operation Start Date",
  "FACILITY_OPERATION_START_DATE_INVALID": "Must be on or after build start and build completed dates.",
  "FACILITY_OPERATION_START_DATE_REQUIRED": "Operation Start Date *",
  "FAILED_PRESCREEN": "Failed Pre-screen",
  "FAILURE_RISK": "Failure Risk",
  "FAMILY": "Family",
  "FAST_GROWTH": "Fast Growth",
  "FAVORABLE_WEATHER": "Favorable Weather",
  "FEATURE_AVAILABLE_ON_DESKTOP": "This feature is only available from the desktop application.",
  "FEATURE_REQUEST": "Feature Request",
  "FEATURE_REQUEST_DESCRIPTION": "Let us know about ideas you have for new capabilities in Terraware.",
  "FEATURE_REQUEST_INSTRUCTIONS": "Provide details about a new feature or modifications to an existing feature. (What use cases or problems will the new feature or changes address?)",
  "FEEDBACK": "Feedback",
  "FEEDBACK_SHARED_WITH_PROJECT": "Feedback (shared with project)",
  "FERN": "Fern",
  "FIELD_NOTES": "Field Notes",
  "FILE_NAME": "File Name",
  "FILE_NAMING": "File Naming",
  "FILE_SELECTED": "File Selected",
  "FILL_OUT_ALL_FIELDS": "Please fill out all required fields.",
  "FILTER": "Filter",
  "FILTER_BY_PROJECT": "Filter by Project",
  "FILTER_SHOW_EMPTY_BATCHES": "Show Empty Batches",
  "FILTERS": "Filters",
  "FINAL_QTY": "Final Qty",
  "FINANCE": "Finance",
  "FINANCIAL_VIABILITY": "Financial Viability",
  "FIND_OUT_MORE_ABOUT_ACCELERATOR_AND_APPLY": "Find out more about Terraformation’s Seed to Carbon Forest Accelerator {0} and apply!",
  "FIRST_ADD_PLANTING_SITE": "To view the dashboard, you need to have a planting site.",
  "FIRST_NAME": "First Name",
  "FIX_HIGHLIGHTED_FIELDS": "Fix the highlighted fields below.",
  "FOOTNOTE_WAIT_FOR_INVITATION_1": "Not interested in creating your own organization, or expecting an invitation to an existing organization?",
  "FOOTNOTE_WAIT_FOR_INVITATION_2": "Don’t worry. You’ll receive an email when an admin from your organization adds you to the organization in Terraware.",
  "FOR_A_FULL_OVERVIEW": "For a full overview of all of our software, visit the [Software Page] on our website.",
  "FOR_LAB_AND_NURSERY_GERMINATION": "For Lab and Nursery Germination",
  "FOR_LAB_GERMINATION": "For Lab Germination",
  "FOR_NURSERY_GERMINATION": "For Nursery Germination",
  "FORB": "Forb",
  "FORESTRY": "Forestry",
  "FREEZER": "Freezer",
  "FREEZER_1": "Freezer 1",
  "FREEZER_2": "Freezer 2",
  "FREEZER_3": "Freezer 3",
  "FRESH": "Fresh",
  "FRIDGE": "Fridge",
  "FROM": "From",
  "FROM_NURSERY": "From: Nursery",
  "FROM_NURSERY_REQUIRED": "From: Nursery *",
  "FROM_SUBZONE": "From: Subzone",
  "FROM_X": "from {0}",
  "FRONT_OF_SEED_BANK": "Front of Seed Bank",
  "FUNDER": "Funder",
  "FUNDER_ADDED": "Funder Added",
  "FUNDER_NAME": "Funder Name",
  "FUNDER_PORTAL": "Funder Portal",
  "FUNDERS": "Funders",
  "FUNDERS_DELETED": "Funders Deleted",
  "FUNDING_ENTITIES": "Funding Entities",
  "FUNDING_ENTITY": "Funding Entity",
  "FUNDING_ENTITY_NAME": "Funding Entity Name",
  "FUNGUS": "Fungus",
  "G": "g",
  "G_GRAMS": "g (grams)",
  "GENERAL": "General",
  "GENERIC_ERROR": "An error occurred",
  "GENUS": "Genus",
  "GEOLOCATIONS": "Geolocations",
  "GEOMETRY_CHANGED_WARNING_MESSAGE": "the geometry of this site {0}. The data shown here may not be representative of what's in the planting zones as of today.",
  "GERMINATED": "Germinated",
  "GERMINATING": "Germinating",
  "GERMINATING_QUANTITY": "Germinating Quantity",
  "GERMINATING_QUANTITY_CANNOT_BE_LESS_THAN_ZERO": "Germinating quantity cannot be less than 0",
  "GERMINATING_QUANTITY_REMAINING": "Germinating Quantity ({0} remaining)",
  "GERMINATING_QUANTITY_REQUIRED": "Germinating Quantity *",
  "GERMINATION_QUANTITY_AFTER": "Germination Quantity (After)",
  "GERMINATION_QUANTITY_BEFORE": "Germination Quantity (Before)",
  "GERMINATION_RATE": "Germination Rate",
  "GET_STARTED": "Get Started",
  "GET_STARTED_SUBTITLE": "To get started, add people to your organization and add the species of the seeds and plants that your organization manages.",
  "GIS": "GIS",
  "GLOBAL_ROLE_ACCELERATOR_ADMIN": "Accelerator Admin",
  "GLOBAL_ROLE_READ_ONLY": "Read Only",
  "GLOBAL_ROLE_SUPER_ADMIN": "Super-Admin",
  "GLOBAL_ROLE_TF_EXPERT": "TF Expert",
  "GO_TO": "Go to {0}",
  "GO_TO_DASHBOARD": "Go to Dashboard",
  "GO_TO_NURSERIES": "Go to Nurseries",
  "GO_TO_PLANTING_SITES": "Go to Planting Sites",
  "GO_TO_PROFILE": "Go to Profile",
  "GO_TO_SEED_BANKS": "Go to Seed Banks",
  "GO_TO_SPECIES": "Go to Species",
  "GOOGLE_FOLDER_URL": "Google Folder URL",
  "GOT_IT": "Got It!",
  "GPS_COORDINATES": "GPS Coordinates",
  "GPX_FILE": "GPX file",
  "GRAMINOID": "Graminoid",
  "GRAMS": "Grams",
  "GREATER_THAN_FIFTY_PERCENT": "> 50%",
  "GROWTH_FORM": "Growth Form",
  "HAS_CHANGED": "has changed",
  "HECTARES": "Hectares",
  "HECTARES_PLANTED_CARD_TITLE": "How much of my site has been marked as \"Planting Complete\"?",
  "HECTARES_PLANTED_DESCRIPTION_1": "This is the total area and percentage of the site that has been marked as \"Planting Complete\".",
  "HECTARES_PLANTED_DESCRIPTION_2": "You can mark subzones within your site as \"Planting Complete\" under the Withdrawals page.",
  "HECTARES_PLANTED_DESCRIPTION_3_COMPLETE": "Currently, all {0} subzones are marked as such.",
  "HECTARES_PLANTED_DESCRIPTION_3_INCOMPLETE": "Currently, {0} out of {1} subzones are marked as such.",
  "HECTARES_PLANTED_DESCRIPTION_4": "For observations, we only assign monitoring plots that we know are a part of these subzones.",
  "HECTARES_PLANTED_DESCRIPTION_LINK": "Go to Withdrawals",
  "HEIGHT_AT_MATURITY": "Height at Maturity (cm)",
  "HEIGHT_M": "Height (m)",
  "HELP_SUPPORT": "Help & Support",
  "HERB": "Herb",
  "HERBACEOUS_ABUNDANCE_PERCENT": "Herbaceous Abundance (%)",
  "HERE": "here",
  "HIGHEST": "Highest",
  "HIGHEST_AND_LOWEST_MORTALITY_RATE_CARD_TITLE": "Which zones have the highest and lowest mortality rates?",
  "HIGHEST_AND_LOWEST_MORTALITY_RATE_SPECIES_CARD_TITLE": "Which species have the highest and lowest mortality rates?",
  "HIGHLIGHTS": "Highlights",
  "HISTORY": "History",
  "HOME": "Home",
  "HOW_MANY_PLANTS_CARD_TITLE": "How many plants have I reported planting?",
  "HOW_MANY_PLANTS_CARD_TITLE_W_OBS": "How many plants are on the site as of {0}?",
  "HOW_MANY_PLANTS_CARD_W_OBS_DESCRIPTION": "This is your total number of plants based on the site size and planting density from your latest observations.",
  "HOW_MANY_PLANTS_CARD_W_OBS_DESCRIPTION_2": "Since then, you have reported planting {0} plants. This is {1}% greater than your total number of plants as of the observation date.",
  "HUBSPOT_LINK": "HubSpot Link",
  "I_AM_THE_ONLY_PERSON": "I am the only person",
  "ID": "ID",
  "IGNORE": "Ignore",
  "IMAGE_UPDATED": "Image updated",
  "IMAGES": "Images",
  "IMPERIAL": "Imperial",
  "IMPERIAL_OZ_LB": "Imperial (oz, lb)",
  "IMPORT": "Import",
  "IMPORT_ACCESSIONS": "Import Accessions",
  "IMPORT_ACCESSIONS_ALT_TITLE": "Already have a seed accession database?",
  "IMPORT_ACCESSIONS_DESC": "Browse or drag and drop a CSV with accessions.",
  "IMPORT_ACCESSIONS_WITH_TEMPLATE": "Import accessions using our CSV template.",
  "IMPORT_INVENTORY": "Import Inventory",
  "IMPORT_INVENTORY_ALT_TITLE": "Already have an inventory database?",
  "IMPORT_INVENTORY_DESC": "Browse or drag and drop a CSV with inventory data.",
  "IMPORT_INVENTORY_DESCRIPTION": "Upload a CSV with species, quantities, and other fields.",
  "IMPORT_INVENTORY_WITH_TEMPLATE": "Import inventory using our CSV template.",
  "IMPORT_SPECIES": "Import Species",
  "IMPORT_SPECIES_DESCRIPTION": "Upload a CSV with scientific names and other optional fields.",
  "IMPORT_SPECIES_LIST": "Import Species List",
  "IMPORT_SPECIES_LIST_DESC": "Browse or drag and drop a CSV with scientific names and other optional fields.",
  "IMPORTING_ACCESSIONS": "Importing accessions... this may take a few minutes.",
  "IMPORTING_DELIVERABLES": "Importing deliverables...this may take a few minutes.",
  "IMPORTING_INVENTORY": "Importing inventory...this may take a few minutes.",
  "IMPORTING_MODULES": "Importing modules...this may take a few minutes.",
  "IMPORTING_SPECIES": "Importing species...this may take a few minutes.",
  "IN_PROGRESS": "In Progress",
  "IN_REVIEW": "In Review",
  "IN_STORAGE": "In Storage",
  "INCLUDE_EMPTY_FIELDS": "Include empty fields",
  "INCOMPLETE": "Incomplete",
  "INCORRECT_EMAIL_FORMAT": "Incorrect email format.",
  "INSTANCES": "Instances",
  "INSUFFICIENT_DATA": "Insufficient Data",
  "INTERMEDIATE": "Intermediate",
  "INTERMEDIATE_COOL_TEMPERATURE_SENSITIVE": "Intermediate - Cool Temperature Sensitive",
  "INTERMEDIATE_PARTIAL_DESICCATION_TOLERANT": "Intermediate - Partial Desiccation Tolerant",
  "INTERMEDIATE_SHORT_LIVED": "Intermediate - Short Lived",
  "INTERNAL_COMMENTS": "Internal Comments",
  "INTERNAL_INTERESTS": "Internal Interests",
  "INVALID_DATE": "Invalid date",
  "INVALID_EDITOR": "This report is being edited by another user",
  "INVALID_VALUE": "Invalid Value",
  "INVASIVE": "Invasive",
  "INVENTORY": "Inventory",
  "INVENTORY_IMPORT_COMPLETE": "Inventory data import complete!",
  "INVENTORY_ONBOARDING_NURSERIES_MSG": "Define nurseries assigned to seedlings inventory",
  "INVENTORY_ONBOARDING_SPECIES_MSG": "Define a list of species used in your seedlings inventory",
  "INVENTORY_PAGE_DESCRIPTION": "Manage your Inventory.",
  "INVESTMENT_COMMITTEE_VOTES": "Investment Committee Votes",
  "INVESTMENT_THESIS": "Investment Thesis",
  "INVITATION_PENDING": "Invitation Pending",
  "INVITE_FUNDER": "Invite Funder",
  "INVITE_FUNDER_DESCRIPTION": "Provide an email address to invite a Funder to the Funder Portal under this Funding Entity. An invitation email to create an account will be sent to the email address. First Name and Last Name will be provided by the account holder.",
  "INVITED": "Invited",
  "ISSUE": "Issue",
  "IUCN_CRITICALLY_ENDANGERED": "Critically Endangered (CR)",
  "IUCN_DATA_DEFICIENT": "Data Deficient (DD)",
  "IUCN_ENDANGERED": "Endangered (EN)",
  "IUCN_EXTINCT": "Extinct (EX)",
  "IUCN_EXTINCT_IN_THE_WILD": "Extinct in the Wild (EW)",
  "IUCN_LEAST_CONCERN": "Least Concern (LC)",
  "IUCN_NEAR_THREATENED": "Near Threatened (NT)",
  "IUCN_NOT_EVALUATED": "Not Evaluated (NE)",
  "IUCN_VULNERABLE": "Vulnerable (VU)",
  "JOIN": "Join",
  "JOIN_EVENT_NAME": "Join {0}",
  "KEEP_ORIGINAL": "Keep Original",
  "KEY_BELONGS_TO_ANOTHER_SEED_BANK": "Key is associated with another seed bank.",
  "KEY_LESSONS": "Key Lessons Learned",
  "KEY_LESSONS_INSTRUCTIONS": "Provide details of key lessons learned during the project reporting period, including both positive and negative unintended consequences if applicable. (One-half page maximum.)",
  "KEY_LESSONS_REQUIRED": "Key Lessons Learned *",
  "KEY_WAS_NOT_RECOGNIZED": "Key was not recognized.",
  "KG": "kg",
  "KG_KILOGRAMS": "kg (kilograms)",
  "KILOGRAMS": "Kilograms",
  "KNOWLEDGE_BASE": "Knowledge Base",
  "LAB": "Lab",
  "LAB_GERMINATION": "Lab Germination",
  "LAND_USE_MODEL_TYPE": "Land Use Model Type",
  "LANDOWNER": "Landowner",
  "LANGUAGE": "Language",
  "LANGUAGE_AND_REGION": "Language and Region",
  "LAST_EDITED": "Last Edited",
  "LAST_EDITED_BY": "Last Edited By",
  "LAST_MODIFIED_BY": "Last modified by",
  "LAST_MODIFIED_ON": "Last modified on",
  "LAST_NAME": "Last Name",
  "LAST_OBSERVATION": "Last Observation: {0}",
  "LAST_OBSERVED": "Last Observed",
  "LAST_UPDATED": "Last Updated",
  "LATEST_OBSERVATION": "Latest Observation",
  "LATITUDE_LONGITUDE": "Latitude, Longitude",
  "LB": "lb",
  "LB_POUNDS": "lb (pounds)",
  "LEARN_MORE": "Learn more",
  "LEARN_MORE_GROWTH_FORM_FERN": "A non-flowering vascular plant that reproduces by spores, in the plant division Pteridophyta.",
  "LEARN_MORE_GROWTH_FORM_FORB": "A herbaceous (non-woody) plant that is NOT a graminoid (grass, sedge, or rush).",
  "LEARN_MORE_GROWTH_FORM_FUNGUS": "Usually a eukaryotic organism (non-plant) that is heterotrophic (cannot produce its own food), grows in filaments (hyphae), and produces spores.",
  "LEARN_MORE_GROWTH_FORM_GRAMINOID": "A herbaceous (non-woody) plant with a grass-like morphology, that is elongated culms with long, blade-like leaves, in the grass, sedge, or rush family.",
  "LEARN_MORE_GROWTH_FORM_HERB": "A small plant without a woody stem whose aerial parts all die back at the end of each growing season.",
  "LEARN_MORE_GROWTH_FORM_LIANA": "A vine/climbing plant with woody stems reaching >10m length.",
  "LEARN_MORE_GROWTH_FORM_LICHEN": "A symbiotic cluster of fungus and alga, fungus being the dominant partner, lending to its thallus shape and fruiting body.",
  "LEARN_MORE_GROWTH_FORM_MOSS": "A non-vascular flowerless plant typically formed as dense green clumps or mats, often in damp or shady locations.",
  "LEARN_MORE_GROWTH_FORM_MULTIPLE_FORMS": "A plant that can grow in more than one form.",
  "LEARN_MORE_GROWTH_FORM_SHRUB": "A woody plant which is smaller than a tree and has several main stems arising at or near the ground.",
  "LEARN_MORE_GROWTH_FORM_SHRUB_TREE": "A plant that can be in the form of either a shrub or a tree.",
  "LEARN_MORE_GROWTH_FORM_SUBSHRUB": "A dwarf shrub, usually only woody at its base.",
  "LEARN_MORE_GROWTH_FORM_TREE": "A woody perennial plant, typically having a single stem or trunk growing to a considerable height and bearing lateral branches at some distance from the ground.",
  "LEARN_MORE_GROWTH_FORM_VINE": "Any plant with long, flexible, climbing stems (term often used for herbaceous climbers)",
  "LEARN_MORE_SEED_STORAGE_BEHAVIOR_INTERMEDIATE": "Seeds are between orthodox and recalcitrant seeds in their behavior; may include tolerating partial desiccation, tolerating cool but not freezing temperatures, or being short-lived regardless of storage conditions.",
  "LEARN_MORE_SEED_STORAGE_BEHAVIOR_LIKELY": "Scientific evidence suggests this seed storage behavior, but further research is needed to confirm.",
  "LEARN_MORE_SEED_STORAGE_BEHAVIOR_ORTHODOX": "Seeds tolerate levels of desiccation required for frozen storage (5-8% moisture content) and temperatures of -20°C or lower.",
  "LEARN_MORE_SEED_STORAGE_BEHAVIOR_RECALCITRANT": "Seeds do not tolerate levels of desiccation required for ex situ (off-site) conservation.",
  "LEARN_MORE_STRATA": "Learn more about site stratification here",
  "LEAVE_AND_SAVE": "Leave and Save",
  "LEAVE_ORGANIZATION": "Leave Organization",
  "LEGAL": "Legal",
  "LEGEND": "Legend",
  "LESS_THAN_TWENTY_FIVE_PERCENT": "< 25%",
  "LIANA": "Liana",
  "LICHEN": "Lichen",
  "LIGHT": "Light",
  "LIKELY_INTERMEDIATE": "Likely Intermediate",
  "LIKELY_INTERMEDIATE_COOL_TEMPERATURE_SENSITIVE": "Likely Intermediate - Cool Temperature Sensitive",
  "LIKELY_INTERMEDIATE_PARTIAL_DESICCATION_TOLERANT": "Likely Intermediate - Partial Desiccation Tolerant",
  "LIKELY_INTERMEDIATE_SHORT_LIVED": "Likely Intermediate - Short Lived",
  "LIKELY_ORTHODOX": "Likely Orthodox",
  "LIKELY_RECALCITRANT": "Likely Recalcitrant",
  "LIMIT_OBSERVATION_LABEL": "Limit observation to selected subzones",
  "LINK": "Link",
  "LIST": "List",
  "LIVE": "Live",
  "LIVE_DEAD_PLANTS_PER_SPECIES_CARD_TITLE": "How many live and dead plants are there per species?",
  "LIVE_PLANTS": "Live Plants",
  "LIVE_PLANTS_OBSERVED": "Live Plants Observed",
  "LIVE_SESSION": "Live Session",
  "LIVE_SESSIONS": "Live Sessions",
  "LOADING": "Loading...",
  "LOCAL_USES_KNOWN": "Local Uses Known",
  "LOCAL_USES_KNOWN_TOOLTIP": "List any important traditional, cultural, social, economic/livelihood uses of the species in your region.",
  "LOCATION": "Location",
  "LOCATION_REQUIRED": "Location *",
  "LOCATIONS": "Locations",
  "LOCKED": "Locked",
  "LOG_FRAME_AND_ME_PLAN_URL": "Logframe and M&E Plan URL",
  "LOG_OUT": "Log Out",
  "LONG_TERM_PERMANENT": "Long-Term/Permanent",
  "LOSS_RATE": "Loss Rate",
  "LOWEST": "Lowest",
  "MANAGED_LOCATION_TYPE_NURSERY": "Nursery",
  "MANAGED_LOCATION_TYPE_PLANTING_SITE": "Planting Site",
  "MANAGED_LOCATION_TYPE_SEED_BANK": "Seed Bank/Seed Collection",
  "MANAGER": "Manager",
  "MANAGER_INFO": "A manager can do the above as well as edit data entries for seeds and manage planting withdrawals, planting sites and species.",
  "MANGROVE": "Mangrove",
  "MANGROVES": "Mangroves",
  "MAP": "Map",
  "MAP_EDITOR_DRAWING_ADDITIONAL_FEATURE": "Add points to your new boundary by clicking on the map. To finish drawing, complete the boundary by either double-clicking or by clicking on the starting point again. The original boundary will be replaced by the new one when you finish drawing.",
  "MAP_EDITOR_DRAWING_FIRST_FEATURE": "Add points to your boundary by zooming in to where your planting site is, and then clicking on the map. To finish drawing, complete the boundary by either double-clicking or by clicking on the starting point again.",
  "MAP_EDITOR_EDITING_FEATURE": "Click and drag a corner of the boundary to adjust its position. Click the midpoint between two corners to add another one. To remove a corner, click on it and then click the {trash} button. When finished, click outside the boundary.",
  "MAP_EDITOR_NO_FEATURES": "Start drawing the boundary of your planting site. When finished, click on the starting point or double-click to complete the boundary.",
  "MAP_EDITOR_NO_SELECTION": "Click on your planting site's boundary if you want to adjust its position or its shape. To replace the boundary with a new one, click the {polygon} button.",
  "MAP_EDITOR_SELECTED_FEATURE": "Hold the mouse button down and drag the boundary to adjust its position. To start adjusting its shape, click on it again. To remove it, click the {trash} button.",
  "MARK_ALL_AS_READ": "Mark All As Read",
  "MARK_AS_COMPLETE": "Mark as Complete",
  "MARK_AS_INCOMPLETE": "Mark as Incomplete",
  "MARK_AS_READ": "Mark As Read",
  "MARK_AS_SUBMITTED": "Mark as Submitted",
  "MARK_AS_SUBMITTED_UNDO": "Undo Mark as Submitted",
  "MARK_AS_UNREAD": "Mark As Unread",
  "MARKED_AS_PLANTING_COMPLETE": "Marked as Planting Complete (%)",
  "MATCH_SPECIES": "Match Species",
  "MATCH_SPECIES_MODAL_DESCRIPTION": "Select matches for the unrecognized species. Once you have matched species, you will not be able to change or undo the match.",
  "MATCH_UNRECOGNIZED_SPECIES": "Match Unrecognized Species",
  "MAX": "Max",
  "MAXIMUM_CARBON_ACCUMULATION": "Maximum Carbon Accumulation (tCO2/ha/yr)",
  "MEASUREMENT_TIME": "Measurement Time",
  "MEDIA": "Media",
  "MEDIA_MIX": "Media Mix",
  "MEETING_URL": "Meeting URL",
  "METHODOLOGY": "Methodology",
  "METRIC": "Metric",
  "METRIC_G_KG_MG": "Metric (g, kg, mg)",
  "METRIC_NOT_VISIBLE_TO_FUNDER": "Metric Not Visible to Funder",
  "METRIC_STATUS_DESCRIPTION_ARCHIVED": "Outcome achieved already",
  "METRIC_STATUS_DESCRIPTION_ON_TRACK": "Outcome on-track to be achieved within the expected timeframe",
  "METRIC_STATUS_DESCRIPTION_UNLIKELY": "Outcome unlikely to be achieved in the expected timeframe",
  "METRIC_TARGET": "Metric Target",
  "METRIC_TARGET_MESSAGE": "Set a target for the next reporting period.",
  "METRIC_TYPE_ACTIVITY": "Activity",
  "METRIC_TYPE_IMPACT": "Impact",
  "METRIC_TYPE_OUTCOME": "Outcome",
  "METRIC_TYPE_OUTPUT": "Output",
  "METRIC_VISIBLE_TO_FUNDER": "Metric Visible to Funder",
  "MG": "mg",
  "MG_MILLIGRAMS": "mg (milligrams)",
  "MIDDLE_OF_SEED_BANK": "Middle of Seed Bank",
  "MILLIGRAMS": "Milligrams",
  "MIN": "Min",
  "MIN_MAX_CARBON_ACCUMULATION": "Min/Max Carbon Accumulation (tCO2/ha/yr)",
  "MIN_PROJECT_AREA": "Minimum Project Area",
  "MINIMUM_CARBON_ACCUMULATION": "Minimum Carbon Accumulation (tCO2/ha/yr)",
  "MISSING_SUBSET_WEIGHT_ERROR_COUNT": "You must enter a subset weight in order to withdraw by count",
  "MISSING_SUBSET_WEIGHT_ERROR_NURSERY": "You must enter in a subset weight in order to withdraw to a nursery. This can be done by editing the quantity of this accession.",
  "MISSING_SUBSET_WEIGHT_ERROR_VIABILITY_TEST": "You must enter in a subset weight in order to create a viability test. This can be done by editing the quantity of this accession.",
  "MITIGATION_PLAN": "Mitigation Plan",
  "MODULE": "Module",
  "MODULE_COHORTS_DESCRIPTION": "Below are a list of Cohorts that have added this module.",
  "MODULE_CONTENT": "Module Content",
  "MODULE_DETAILS": "Module Details",
  "MODULE_ID": "Module ID",
  "MODULES": "Modules",
  "MODULES_IMPORT_COMPLETE": "Modules data import complete!",
  "MONITORING": "Monitoring",
  "MONITORING_CARD_DESCRIPTION": "Add seed banks to your organization and then monitor things like temperature and humidity through their sensor kits.",
  "MONITORING_DATE_FORMAT": "MMM d h:mma",
  "MONITORING_LABEL_HUMIDITY": "Humidity",
  "MONITORING_LABEL_HUMIDITY_THRESHOLDS": "Humidity Thresholds",
  "MONITORING_LABEL_STATE_OF_CHARGE": "State of Charge",
  "MONITORING_LABEL_SYSTEM_POWER": "System Power",
  "MONITORING_LABEL_TEMPERATURE": "Temperature",
  "MONITORING_LABEL_TEMPERATURE_THRESHOLDS": "Temperature Thresholds",
  "MONITORING_PLOT": "Monitoring Plot",
  "MONITORING_PLOT_TYPE": "Monitoring Plot Type",
  "MONITORING_PLOTS": "Monitoring Plots",
  "MONOCULTURE": "Monoculture",
  "MONTH_01": "January",
  "MONTH_02": "February",
  "MONTH_03": "March",
  "MONTH_04": "April",
  "MONTH_05": "May",
  "MONTH_06": "June",
  "MONTH_07": "July",
  "MONTH_08": "August",
  "MONTH_09": "September",
  "MONTH_10": "October",
  "MONTH_11": "November",
  "MONTH_12": "December",
  "MORE_INFO": "More Info",
  "MORE_OPTIONS": "More Options",
  "MORTALITY_BREAKDOWN": "Mortality Breakdown",
  "MORTALITY_BREAKDOWN_TOOLTIP": "Mortality breakdown shows the numbers of plants per species that were recorded as live and dead within all of the zones that were observed.",
  "MORTALITY_RATE": "Mortality Rate",
  "MORTALITY_RATE_CARD_TITLE": "What is my plant mortality rate as of {0}?",
  "MORTALITY_RATE_CLARIFICATION": "This is the total percentage of your plantings that have died across all species and zones",
  "MORTALITY_RATE_IN_FIELD": "Mortality Rate in Field (%)",
  "MORTALITY_RATE_IN_FIELD_REQUIRED": "Mortality Rate in Field (%) *",
  "MORTALITY_RATE_INFO": "Mortality rate is based on the number of plants that were observed as dead within the zones that are fully planted.",
  "MORTALITY_RATE_PER_SPECIES": "Mortality Rate per Species",
  "MORTALITY_RATE_PERCENT": "Mortality Rate (%)",
  "MORTALITY_RATE_PERCENT_REQUIRED": "Mortality Rate (%) *",
  "MORTALITY_RATE_TOOLTIP": "Mortality rate is based on the number of plants that were observed as dead within all of the zones that were observed.",
  "MORTALITY_RATE_TREND_TOOLTIP": "Mortality Rate trend represents the percentages of plants that were recorded as dead in permanent plots within all observations.",
  "MOSS": "Moss",
  "MOST_RECENT_OBSERVATION": "Most Recent Observation",
  "MOVE": "Move",
  "MULTIPLE_FORMS": "Multiple Forms",
  "MY_ACCOUNT": "My Account",
  "MY_ACCOUNT_COOKIES_DESC": "For more information on how we use cookies to improve the performance of Terraware, please see our cookie policy.",
  "MY_ACCOUNT_DESC": "Manage your account information.",
  "MY_ACCOUNT_NOTIFICATIONS_DESC": "Notifications alert you when there are important updates about your organizations. You will receive them through email.",
  "NAME": "Name",
  "NAME_REQUIRED": "Name *",
  "NAME_UNKNOWN": "(name unknown)",
  "NAME_USED_BY_PROJECT": "Name Used by Project",
  "NATIVE": "Native",
  "NATIVE_ECOSYSTEM": "Native Ecosystem",
  "NATIVE_ECOSYSTEM_TOOLTIP": "List the ecosystem type where this species is found naturally, may include details such as elevation range, rainfall, etc",
  "NATIVE_FOREST": "Native Forest",
  "NATIVE_NON_NATIVE": "Native/Non-Native",
  "NEEDS_TRANSLATION": "Needs Translation",
  "NEW": "New",
  "NEW_ACCESSION": "Add Accession",
  "NEW_APP_VERSION": "Please refresh to use the latest version of Terraware.",
  "NEW_APP_VERSION_MOBILE": "Refresh for the latest Terraware version.",
  "NEW_SUBZONE": "New Subzone",
  "NEW_TEMPLATE_MODAL_DESCRIPTION": "A new version has been published for this document's documentTemplate. Would you like to update?",
  "NEW_TEMPLATE_MODAL_TITLE": "Update DocumentTemplate Version",
  "NEW_ZONE": "New Zone",
  "NEXT": "Next",
  "NEXT_STEPS": "Next Steps",
  "NEXT_STEPS_INSTRUCTIONS": "Summarize the next phases in your project. (One-quarter page maximum.)",
  "NEXT_STEPS_REQUIRED": "Next Steps *",
  "NICE": "Nice!",
  "NO": "No",
  "NO_AVAILABLE_PROJECTS_FOR_SPECIES": "There are no remaining projects available for this species.",
  "NO_BATCHES_TO_WITHDRAW_FROM": "There are no batches with withdrawable quantities.",
  "NO_COMMENTS_ADDED": "No comments added",
  "NO_DATA_YET": "No data yet",
  "NO_FUTURE_DATES": "No future dates allowed",
  "NO_INVENTORY_DESCRIPTION": "It looks like you haven’t added inventory yet. You can either import data from a CSV file, or add inventory using our inventory form.",
  "NO_LINK_ADDED": "No link added",
  "NO_LOCATION_FOUND": "Location not found",
  "NO_MAP_DATA": "No map data to show for this planting site.",
  "NO_MORTALITY_RATE_WARNING": "The data from this Observation is insufficient to calculate mortality rates. Mortality rates are based on Observations including permanent plots.",
  "NO_NOTIFICATIONS": "No notifications to show.",
  "NO_NURSERIES_NON_ADMIN_MSG": "Before you can add and manage your nursery inventory, you’ll need to have a nursery and species within Terraware. Only admins can add nurseries; please reach out to yours for assistance.",
  "NO_OBSERVATIONS_HAVE_BEEN_SCHEDULED": "No observations have been scheduled",
  "NO_PARTICIPANT": "No Participant",
  "NO_PLANTING_SITES_CONTRIBUTOR_MSG": "Before you can view the Plants Dashboard, you’ll need to have a planting site set up in Terraware. Only admins can set up planting sites; please reach out to yours for assistance.",
  "NO_PLANTING_SITES_DESCRIPTION": "Start by adding a planting site. Adding a planting site will allow you to track where seedlings go after they leave the nursery.",
  "NO_PLANTING_SITES_TITLE": "Just a moment, let’s add a planting site first.",
  "NO_PLANTS": "No Plants",
  "NO_PROJECT": "No Project",
  "NO_PROJECT_SPECIFIC_METRICS_TO_SHOW": "No Project Specific Metrics to show.",
  "NO_QUANTITY_SET": "No quantity set",
  "NO_REASSIGNMENTS": "No Reassignments",
  "NO_REASSIGNMENTS_TEXT": "Select a new subzone with quantity in at least one seedlings batch row.",
  "NO_REPORTS_TO_SHOW": "No reports to show.",
  "NO_SEEDBANKS_ADMIN_TITLE": "Just a moment, let’s add a seed bank first.",
  "NO_SEEDBANKS_MONITORING_ADMIN_MSG": "Start by adding a seed bank. If your seed bank was built by Terraformation, you’ll then be able to monitor things like the seed bank's temperature and humidity.",
  "NO_SEEDBANKS_MONITORING_NON_ADMIN_MSG": "Before you can begin remotely monitoring things like temperature and humidity through a seed bank’s sensor kit, you’ll need to add a seed bank within Terraware. Only admins can add seed banks, so please reach out to yours for assistance.",
  "NO_SEEDBANKS_NON_ADMIN_MSG": "Before you can add and manage your accessions, you’ll need to have a seed bank and species within Terraware. Only admins can add seed banks; please reach out to yours for assistance.",
  "NO_SEEDBANKS_SET_UP_NON_ADMIN_MSG": "If your seed bank was built by Terraformation, it is equipped with a sensor kit that you can remotely monitor things like the seed bank's temperature and humidity. Your seed bank either does not have a sensor kit, or it has not yet been set up by your administrator.",
  "NO_SPECIES": "No Species",
  "NO_SPECIES_CONTRIBUTOR_MSG": "There are no species in your species list yet. Only admins can add species, so please reach out to yours for assistance.",
  "NO_SPECIES_DESCRIPTION": "It looks like you haven’t added any species yet. Having a master species list helps streamline your organization’s seed and plant data entry. You can either add species manually and individually, or import data from a CSV.",
  "NO_SUB_LOCATIONS": "Edit this seed bank to add sub-locations.",
  "NO_SUB_LOCATIONS_NURSERY": "Edit this nursery to add sub-locations.",
  "NO_VOTERS": "No Voters",
  "NO_VOTERS_FOR_PROJECT": "There are no voters for this project. Contact an accelerator admin to add voters.",
  "NO_WITHDRAWABLE_QUANTITIES_FOUND": "No withdrawable quantities found",
  "NON_NATIVE": "Non-Native",
  "NONE": "None",
  "NOT_ACCEPTED": "Not Accepted",
  "NOT_COMPLETE": "Not Complete",
  "NOT_CONNECTED": "Not Connected",
  "NOT_ENOUGH_SEEDS_IN_ACCESSION": "Not enough seeds in accession",
  "NOT_NEEDED": "Not Needed",
  "NOT_OBSERVED": "Not Observed",
  "NOT_READY": "Not Ready",
  "NOT_READY_QUANTITY": "Not Ready Quantity",
  "NOT_READY_QUANTITY_AFTER": "Not Ready Quantity (After)",
  "NOT_READY_QUANTITY_BEFORE": "Not Ready Quantity (Before)",
  "NOT_READY_QUANTITY_CANNOT_BE_LESS_THAN_ZERO": "Not Ready quantity cannot be less than 0",
  "NOT_READY_QUANTITY_REMAINING": "Not Ready Quantity ({0} remaining)",
  "NOT_READY_QUANTITY_REQUIRED": "Not Ready Quantity *",
  "NOT_SUBMITTED": "Not Submitted",
  "NOT_YET": "Not Yet",
  "NOTE_ANY_ISSUES": "Does everything above look right? Note any issues.",
  "NOTE_COLON": "Note:",
  "NOTES": "Notes",
  "NOTES_AFTER": "Notes (After)",
  "NOTES_BEFORE": "Notes (Before)",
  "NOTIFICATIONS": "Notifications",
  "NUMBER_OF_COMMUNITIES_WITHIN_PROJECT_AREA": "Number of Communities Within Project Area",
  "NUMBER_OF_LIVE_PLANTS_PER_SPECIES": "Number of Live Plants per Species",
  "NUMBER_OF_NATIVE_SPECIES": "Number of Native Species",
  "NUMBER_OF_PEOPLE": "Number of People",
  "NUMBER_OF_PHOTOS": "Number of Photos",
  "NUMBER_OF_PLANTS": "Number of Plants",
  "NUMBER_OF_PLOTS_IN_MOST_RECENT_OBSERVATION": "Number of Plots in Most Recent Observation",
  "NUMBER_OF_SEEDS_COMPROMISED": "# Seeds Compromised",
  "NUMBER_OF_SEEDS_COMPROMISED_REQUIRED": "# Seeds Compromised *",
  "NUMBER_OF_SEEDS_COMPROMISED_V2": "# Seeds Compromised",
  "NUMBER_OF_SEEDS_EMPTY": "# Seeds Empty",
  "NUMBER_OF_SEEDS_EMPTY_REQUIRED": "# Seeds Empty *",
  "NUMBER_OF_SEEDS_EMPTY_V2": "# Seeds Empty",
  "NUMBER_OF_SEEDS_FILLED": "# Seeds Filled",
  "NUMBER_OF_SEEDS_FILLED_REQUIRED": "# Seeds Filled *",
  "NUMBER_OF_SEEDS_FILLED_V2": "# Seeds Filled",
  "NUMBER_OF_SEEDS_GERMINATED": "# Seeds Germinated",
  "NUMBER_OF_SEEDS_GERMINATED_REQUIRED": "# Seeds Germinated *",
  "NUMBER_OF_SEEDS_TESTED": "# Seeds Tested",
  "NUMBER_OF_SEEDS_TESTED_REQUIRED": "# Seeds Tested *",
  "NUMBER_OF_SMALL_TREES": "Number of Small Trees",
  "NUMBER_OF_SPECIES": "Number Of Species",
  "NUMBER_OF_SPECIES_PLANTED_CARD_TITLE": "How many species have I reported planting?",
  "NUMBER_PLANTS_COLLECTED_FROM": "Estimated Number of Plants Collected From",
  "NURSERIES": "Nurseries",
  "NURSERY": "Nursery",
  "NURSERY_ADDED": "Nursery Added",
  "NURSERY_CAPACITY": "Nursery Capacity",
  "NURSERY_CAPACITY_REQUIRED": "Nursery Capacity *",
  "NURSERY_GERMINATION": "Nursery Germination",
  "NURSERY_MEDIA": "Nursery Media",
  "NURSERY_MORTALITY_RATE": "Nursery Mortality Rate",
  "NURSERY_REQUIRED": "Nursery *",
  "NURSERY_TRANSFER": "Nursery Transfer",
  "NURSERY_TRANSFERS_REQUIRE_DESTINATIONS": "Nursery transfers require a source and destination nursery.",
  "OBSERVATION_END_DATE": "Observation End Date",
  "OBSERVATION_ENDED": "Observation Ended",
  "OBSERVATION_ENDED_MESSAGE": "The {0} observation has been ended.",
  "OBSERVATION_EVENT_SCHEDULED": "Observation event is scheduled for {0} for planting site(s):",
  "OBSERVATION_IN_PROGRESS": "Observation in Progress",
  "OBSERVATION_OVERDUE": "Observation Overdue",
  "OBSERVATION_PERIOD_WARN": "Observation period cannot exceed two months.",
  "OBSERVATION_RECENCY": "Observation Recency",
  "OBSERVATION_RESCHEDULED": "Observation rescheduled!",
  "OBSERVATION_SCHEDULED": "Observation scheduled!",
  "OBSERVATION_START_DATE": "Observation Start Date",
  "OBSERVATION_STATUS": "Observation Status",
  "OBSERVATION_STATUS_OUTSTANDING": "Outstanding",
  "OBSERVATION_TYPE": "Observation Type",
  "OBSERVATIONS": "Observations",
  "OBSERVATIONS_COMPLETION_PERCENTAGE": "Observations for {0} of {1} monitoring plots ({2}%) have been completed.",
  "OBSERVATIONS_DOWNLOAD_APP": "To complete observations, download the Terraware app on the App Store or Google Play.",
  "OBSERVATIONS_EMPTY_STATE_MESSAGE_1": "There are currently no assigned plot observations.",
  "OBSERVATIONS_EMPTY_STATE_MESSAGE_2": "Observations with assigned plots can be scheduled for planting sites that have had plants allocated to them through inventory withdrawals.",
  "OBSERVATIONS_EMPTY_STATE_TITLE": "No Observations Yet",
  "OBSERVATIONS_MAP_VIEW_PROMPT": "In order to access map view, please select a single planting site.",
  "OBSERVATIONS_REQUIRED_BY_DATE": "{0} monitoring plots require observation by {1}.",
  "OBSERVATIONS_WITH_THE_TERRAWARE_APP": "Observations with the Terraware App",
  "OBSERVED_DATE": "Observed Date",
  "OBSERVED_DENSITY": "Observed Density",
  "OBSERVED_DENSITY_PER_ZONE": "Observed Density Per Zone",
  "OBSERVED_DENSITY_PER_ZONE_TOOLTIP": "Observed density is based on the number of plants observed within the zones that have been observed at least once in this Observation.",
  "OBSERVED_DENSITY_TOOLTIP": "Observed density is based on the number of plants observed within the zones that were observed at least once in this Observation.",
  "OBSERVED_PLANTS": "Observed Plants",
  "OBSERVED_PLANTS_CARD_DESCRIPTION_1": "This is the total number of species found in your latest observations.",
  "OBSERVED_PLANTS_CARD_DESCRIPTION_2": "You have reported planting {0} species total. The difference in these numbers may be because not all the species you planted were found in the monitoring plots, or because you have planted more species since your last observations.",
  "OBSERVED_PLANTS_CARD_TITLE": "How many species are on the site as of {0}?",
  "OBSERVED_SPECIES": "Observed Species",
  "OBSERVER": "Observer",
  "OK": "Ok",
  "ON_TRACK": "On-Track",
  "ONBOARDING_ADMIN_TITLE": "Just a moment, let’s complete setup first",
  "ONBOARDING_NON_ADMINS_MESSAGE": "Before you can manage accessions and seedling inventory, an administrator of your organization will need to set up a seed bank and a nursery in Terraware. Please reach out to an administrator for assistance.",
  "ONE_ON_ONE_SESSION": "1:1 Session",
  "ONE_ON_ONE_SESSIONS": "1:1 Sessions",
  "ONE_OR_MORE_ANSWERS_NEEDED_UPDATES": "One or more answers needed updates. View them below to see each answer's feedback.",
  "ONE_OR_MORE_ANSWERS_WERE_NOT_ACCEPTED": "One or more answers were not accepted. View them below to see each answer's feedback.",
  "OPERATION_CAPACITY": "Operation Capacity",
  "OPPORTUNITIES": "Opportunities",
  "OPPORTUNITIES_INSTRUCTIONS": "This may include opportunities for project expansion, new markets, referrals, training to other organizations, etc. (One-quarter page maximum.)",
  "OPPORTUNITIES_REQUIRED": "Opportunities *",
  "OPT_IN": "Opt-In Features",
  "OPTIONAL": "Optional",
  "OR": "OR",
  "OR_SHRUBS": "OR Shrubs",
  "ORG_NOTIFICATION_ACTION": "To change the preference, go to [Settings > Organization]",
  "ORGANIZATION": "Organization",
  "ORGANIZATION_ADDED": "Organization Added",
  "ORGANIZATION_CREATE_FAILED": "Unable to create organization.",
  "ORGANIZATION_CREATED_MSG": "You can access the organizations you’re in by clicking the user profile menu in the top right corner.",
  "ORGANIZATION_CREATED_MSG_DESKTOP": "You can access the organizations you’re in by clicking the arrow in the top left corner next to the logo.",
  "ORGANIZATION_CREATED_TITLE": "You have created {0}!",
  "ORGANIZATION_DESC": "Manage your organization.",
  "ORGANIZATION_ID": "Organization ID",
  "ORGANIZATION_NAME": "Organization Name",
  "ORGANIZATION_NAME_REQUIRED": "Organization Name *",
  "ORGANIZATION_TYPE": "Organization Type",
  "ORGANIZATION_TYPE_ACADEMIA": "University or Other Academic Institution",
  "ORGANIZATION_TYPE_ARBORETA": "Botanical Gardens or Arboreta",
  "ORGANIZATION_TYPE_DESCRIPTION": "Organization Description",
  "ORGANIZATION_TYPE_FOR_PROFIT": "For-Profit Organization",
  "ORGANIZATION_TYPE_GOVERNMENT": "Governmental Agency",
  "ORGANIZATION_TYPE_NGO": "Non-Governmental Organizations (NGO)",
  "ORGANIZATION_TYPE_OTHER": "Other",
  "ORGANIZATION_WEBSITE": "Organization Website",
  "ORGANIZATIONS": "Organizations",
  "ORIGINAL_QTY": "Original Qty",
  "ORIGINAL_SUBZONE": "Original Subzone",
  "ORIGINAL_ZONE": "Original Zone",
  "ORTHODOX": "Orthodox",
  "OTHER": "Other",
  "OTHER_FACTS": "Other Facts",
  "OTHER_LAND_USE_MODEL": "Other Land-Use Model",
  "OTHER_SPECIES": "Other Species",
  "OTHER_TIMBER": "Other Timber",
  "OUNCES": "Ounces",
  "OUT_PLANTING": "Out-planting",
  "OUTDOORS": "Outdoors",
  "OUTPLANT": "Outplant",
  "OUTPLANTS_REQUIRE_PLANTING_SITES": "Outplants require a planting site for allocation.",
  "OUTPLANTS_REQUIRE_READY_SEEDLINGS": "Outplants require batches with seedlings that are \"ready.\"",
  "OUTSTANDING": "Outstanding",
  "OVER_WORD_LIMIT": "Over word limit",
  "OVERALL_SCORE": "Overall Score",
  "OVERDUE": "Overdue",
  "OVERVIEW": "Overview",
  "OVERWRITTEN_ORIGINAL_VALUE": "Overwritten - original: {0}",
  "OWNER": "Owner",
  "OZ": "oz",
  "OZ_OUNCES": "oz (ounces)",
  "PAGINATION_FOOTER": "{0} to {1} of {2}",
  "PAGINATION_FOOTER_EMPTY": "0 of 0",
  "PAPER": "Paper",
  "PAPER_PETRI_DISH": "Paper Petri Dish",
  "PARTIAL_ERRORS": "Some of the requests failed. You can retry again later.",
  "PARTIAL_ERRORS_TITLE": "Partial Errors",
  "PARTICIPANT": "Participant",
  "PARTICIPANTS": "Participants",
  "PARTICIPANTS_EMPTY_STATE": "You have no participants yet. When you add participants you will see them here.",
  "PASSED_PRESCREEN": "Passed Pre-screen",
  "PENDING": "Pending",
  "PEOPLE": "People",
  "PEOPLE_CARD_DESCRIPTION": "We can’t do it alone! Add people to your Organization and assign them roles.",
  "PER_HECTARE_ESTIMATED_BUDGET": "Per Hectare Estimated Budget (USD)",
  "PERCENTAGE_OF_SITE_PLANTED": "{0}% of Site",
  "PERCENTAGE_OF_TARGET_PLANTING_DENSITY": "{0}% of Target",
  "PERCENTAGE_VALUE": "{0}%",
  "PERIOD_LAST_12_HOURS": "Last 12 hours",
  "PERIOD_LAST_24_HOURS": "Last 24 hours",
  "PERIOD_LAST_30_DAYS": "Last 30 days",
  "PERIOD_LAST_7_DAYS": "Last 7 days",
  "PERLITE_VERMICULITE": "Perlite/Vermiculite",
  "PERMANENT": "Permanent",
  "PERSON_ADDED": "Person Added",
  "PESTS": "Pests",
  "PH": "pH",
  "PHASE": "Phase",
  "PHASE_0": "Phase 0 - Due Diligence",
  "PHASE_0_SCORE": "Phase 0 Score",
  "PHASE_0_TRUNC": "Phase 0",
  "PHASE_1": "Phase 1 - Feasibility Study",
  "PHASE_1_SCORE": "Phase 1 Score",
  "PHASE_1_TRUNC": "Phase 1",
  "PHASE_2": "Phase 2 - Plan and Scale",
  "PHASE_2_TRUNC": "Phase 2",
  "PHASE_3": "Phase 3 - Implement and Monitor",
  "PHASE_3_TRUNC": "Phase 3",
  "PHASE_ID": "Phase ID",
  "PHOTO_NORTHEAST_QUADRAT": "Northeast Quadrat",
  "PHOTO_NORTHWEST_QUADRAT": "Northwest Quadrat",
  "PHOTO_SOUTHEAST_QUADRAT": "Southeast Quadrat",
  "PHOTO_SOUTHWEST_QUADRAT": "Southwest Quadrat",
  "PHOTOS": "Photos",
  "PHOTOS_TO_UPLOAD": "Photos to Upload",
  "PHOTOS_TO_UPLOAD_LIMIT": "(Limit of {0} more)",
  "PLACEHOLDER": "Placeholder",
  "PLANT": "plant",
  "PLANT_DESCRIPTION": "Plant Notes",
  "PLANT_DETAIL": "Plant Detail",
  "PLANT_ID": "Plant ID",
  "PLANT_ID_IF_APPLICABLE": "Plant ID (if applicable)",
  "PLANT_LABEL": "Plant",
  "PLANT_MATERIAL_SOURCE_METHOD_MANGROVE_PROPAGULES": "Mangrove propagules",
  "PLANT_MATERIAL_SOURCE_METHOD_SEED_COLLECTION_AND_GERMINATION": "Seed collection and germination",
  "PLANT_MATERIAL_SOURCE_METHOD_SEED_PURCHASE_AND_GERMINATION": "Seed purchase and germination",
  "PLANT_MATERIAL_SOURCE_METHOD_SEEDLING_PURCHASE": "Seedling purchase",
  "PLANT_MATERIAL_SOURCE_METHOD_VEGETATIVE_PROPAGATION": "Vegetative propagation",
  "PLANT_MATERIAL_SOURCE_METHOD_WILDLING_HARVEST": "Wildling harvest",
  "PLANT_MATERIAL_SOURCING_METHOD": "Plant Material Sourcing Method",
  "PLANT_MATERIAL_SOURCING_METHOD_TOOLTIP_MANGROVE_PROPAGULES": "Mangrove propagules - seedlings that germinate on, then detach from the mother plant (natural dispersal units of mangroves)",
  "PLANT_MATERIAL_SOURCING_METHOD_TOOLTIP_SEED_COLLECTION_AND_GERMINATION": "Seed collection and germination - seeds collected from wild plants germinated in a nursery or seed bank",
  "PLANT_MATERIAL_SOURCING_METHOD_TOOLTIP_SEED_PURCHASE_AND_GERMINATION": "Seed purchase and germination - seeds purchased from local suppliers germinated in a nursery or seed bank",
  "PLANT_MATERIAL_SOURCING_METHOD_TOOLTIP_SEEDLING_PURCHASE": "Seedling purchase - buying seedlings from a local nursery",
  "PLANT_MATERIAL_SOURCING_METHOD_TOOLTIP_VEGETATIVE_PROPAGATION": "Vegetative propagation - clonal propagation, e.g. cuttings, air layering, grafting",
  "PLANT_MATERIAL_SOURCING_METHOD_TOOLTIP_WILDLING_HARVEST": "Wildling harvest - seedlings harvested from natural forests and subsequently replanted",
  "PLANT_MONITORING": "Plant Monitoring",
  "PLANTED_NUMBERS_INFO": "Planted numbers are based on numbers of plants withdrawn to the planting site.",
  "PLANTED_PLANTS": "Planted Plants",
  "PLANTED_SPECIES": "Planted Species",
  "PLANTED_SPECIES_NUMBER": "Planted Species ({0})",
  "PLANTED_SPECIES_TOOLTIP": "Planted Species shows the percentages of each of the species planted. The top 4 species are named, and the rest are included in Other Species.",
  "PLANTING": "Planting",
  "PLANTING_COMPLETE": "Planting Complete?",
  "PLANTING_COMPLETE_AREA": "Planting Complete Area",
  "PLANTING_COMPLETE_DASHBOARD": "Planting Complete",
  "PLANTING_COMPLETE_DASHBOARD_TOOLTIP": "Planting Complete includes the total area and percentage of the site that have been marked as \"Planting Complete\".",
  "PLANTING_COMPLETE_TOOLTIP": "Have you completed all of your planting in this subzone?",
  "PLANTING_DENSITY": "Planting Density",
  "PLANTING_DENSITY_CARD_TITLE": "What is my planting density as of {0}?",
  "PLANTING_DENSITY_DESCRIPTION": "This is your planting density as calculated from your latest observations.",
  "PLANTING_DENSITY_MISSING_TOOLTIP": "When an observation is completed, the calculated planting density will appear here.",
  "PLANTING_DENSITY_OF_PLANTED_ZONES": "Planting Density (of Planted Zones)",
  "PLANTING_DENSITY_PER_ZONE_CARD_TITLE": "What is my target planting density per zone?",
  "PLANTING_DENSITY_PER_ZONE_DESCRIPTION": "This is your zone’s target planting density which you’ve provided. If you’d like to change the target planting densities, please reach out to Terraformation.",
  "PLANTING_DENSITY_PER_ZONE_W_OBS_CARD_TITLE": "What is my target planting density and planting density as of {0} per zone?",
  "PLANTING_DENSITY_UPDATE_DESCRIPTION": "Since then you have reported new plantings that suggest a planting density of {0} plants/ha.",
  "PLANTING_PROGRESS": "Planting Progress",
  "PLANTING_PROGRESS_AND_DENSITY": "Planting Progress and Density",
  "PLANTING_PROGRESS_CARD_TITLE": "What is my site planting progress?",
  "PLANTING_PROGRESS_DESCRIPTION_1": "This is your site’s planting progress as calculated from what has been reported in your nursery withdrawals.",
  "PLANTING_PROGRESS_DESCRIPTION_2": "Once your entire planting site has been marked as complete for planting and you’ve completed your observations, you’ll be able to view your site’s planting density.",
  "PLANTING_PROGRESS_MAP_DESCRIPTION": "Click on each subzone to mark areas where planting has been completed. Planting density will be calculated once planting has been completed for each zone.",
  "PLANTING_PROGRESS_PER_ZONE_CARD_TITLE": "What is my planting progress per zone?",
  "PLANTING_PROGRESS_PER_ZONE_DESCRIPTION_1": "This is your zone’s planting progress calculated from what has been reported in your nursery withdrawals.",
  "PLANTING_PROGRESS_PER_ZONE_DESCRIPTION_2": "Once a zone has been marked as complete for planting and you’ve completed your observations, you’ll be able to view that zone’s planting density.",
  "PLANTING_PROGRESS_PERCENT": "Planting Progress (%)",
  "PLANTING_PROGRESS_TABLE_DESCRIPTION": "Use the checkboxes next to each subzone to mark areas where planting has been completed. Planting density will be calculated once planting has been completed for each zone.",
  "PLANTING_SEASON_END": "Planting Season End",
  "PLANTING_SEASON_END_IN_PAST": "End date may not be in the past.",
  "PLANTING_SEASON_END_OUT_OF_RANGE": "Must be between 4 weeks and 1 year from start date.",
  "PLANTING_SEASON_NO_OVERLAP": "Overlaps planting season {0} - {1}",
  "PLANTING_SEASON_START": "Planting Season Start",
  "PLANTING_SEASON_START_OUT_OF_RANGE": "Must be within 1 year of current date.",
  "PLANTING_SITE": "Planting Site",
  "PLANTING_SITE_AREA": "Planting Site Area",
  "PLANTING_SITE_CREATE_DETAILED_HELP": "If you are a Terraformation partner or accelerator participant, you may [contact us] to work together on a detailed planting site.",
  "PLANTING_SITE_CREATE_DETAILED_TITLE": "Detailed Planting Site Map",
  "PLANTING_SITE_CREATE_EXCLUSIONS_INSTRUCTIONS_DESCRIPTION": "This video shows how to use the drawing {0} tool to draw the exclusion areas of the planting site.",
  "PLANTING_SITE_CREATE_EXCLUSIONS_INSTRUCTIONS_TITLE": "Drawing Exclusion Area Boundaries",
  "PLANTING_SITE_CREATE_INSTRUCTIONS_DESCRIPTION": "This video shows how to use the drawing {0} tool to draw the boundary of the planting site.",
  "PLANTING_SITE_CREATE_INSTRUCTIONS_TITLE": "Drawing Site Boundaries",
  "PLANTING_SITE_DELETED": "Planting site deleted!",
  "PLANTING_SITE_PROGRESS": "Planting Site Progress",
  "PLANTING_SITE_SAVED": "Planting Site Saved",
  "PLANTING_SITE_TRENDS": "Planting Site Trends",
  "PLANTING_SITE_TYPE": "Planting Site Type",
  "PLANTING_SITE_TYPE_DETAILED": "Detailed",
  "PLANTING_SITE_TYPE_SIMPLE": "Simple",
  "PLANTING_SITE_ZONE_NAME_HELP": "Readable names will help people in the field identify areas when out in the field.",
  "PLANTING_SITES": "Planting Sites",
  "PLANTING_ZONE": "Planting Zone",
  "PLANTING_ZONES": "Planting Zones",
  "PLANTINGS_REQUIRE_PLANTING_SITES": "Plantings require a planting site for allocation.",
  "PLANTINGS_REQUIRE_READY_SEEDLINGS": "Plantings require batches with seedlings that are \"ready.\"",
  "PLANTS": "Plants",
  "PLANTS_AND_SPECIES_STATISTICS": "Plants and Species Statistics",
  "PLANTS_CARD_DESCRIPTION": "They’ve taken root! View all your plants in one place.",
  "PLANTS_PER_HA": "Plants per Ha",
  "PLANTS_PER_HA_TOOLTIP": "Plants per Ha trend represents the numbers of plants per ha, as observed within all observations.",
  "PLANTS_PER_HECTARE": "plants/ha",
  "PLEASE_NOTE": "Please Note:",
  "PLEASE_TRY_AGAIN": "Please try again.",
  "PLOT": "Plot",
  "PLOT_CONDITIONS": "Plot Conditions",
  "PLOT_DESCRIPTION": "Plot Description",
  "PLOT_PHOTO": "Plot Photo",
  "PLOT_REPLACES_THIS_25M_PLOT": "Plot replaces this 25x25m plot:",
  "PLOT_SELECTION": "Plot Selection",
  "PLOT_TYPE": "Plot Type",
  "PLOTS_AD_HOC": "Ad Hoc Plots",
  "PLOTS_PERMANENT": "Permanent Plots",
  "PLOTS_SIZE_NOTE": "*Data collected with 25x25m plots",
  "PLOTS_TEMPORARY": "Temporary Plots",
  "POM_M": "POM (m)",
  "POSITION": "Position",
  "POUNDS": "Pounds",
  "PREFERRED_WEIGHT_SYSTEM": "Preferred Weight System",
  "PRELIMINARY_SPECIES_USAGE_LIST_NOT_ACCEPTED": "Preliminary Species Usage List Not Accepted",
  "PRELIMINARY_SPECIES_USAGE_LIST_UPDATE_NEEDED": "Preliminary Species Usage List Update Needed",
  "PRELIMINARY_SPECIES_USAGE_LIST_UPDATE_REQUESTED": "Preliminary Species Usage List Update Requested",
  "PREPARATION_MATERIALS": "Preparation Materials",
  "PRESCREEN": "Pre-screen",
  "PRESCREEN_FAILED": "Pre-screen Failed",
  "PREVIEW": "Preview",
  "PREVIEW_ERROR": "Could not open preview. Please check popup-blocking settings.",
  "PREVIOUS": " Previous",
  "PREVIOUS_25M_PLOT": "Previous 25x25m Plot",
  "PREVIOUS_25M_PLOT_TOOLTIP": "This is the 25x25m plot in the latest Observation that the current 30x30m plot replaces.",
  "PREVIOUS_25M_PLOTS": "Previous 25x25m Plots",
  "PREVIOUS_25M_PLOTS_TOOLTIP": "These are the 25x25m plots in the latest Observation that the current 30x30m plot replaces.",
  "PRIVACY_POLICY": "Privacy Policy",
  "PROBLEMS": "Problems",
  "PROBLEMS_WITH_ENTRIES": "There was a problem with some entries on this form.",
  "PROCESSING": "Processing",
  "PROCESSING_STATUS_REQUIRED": "Processing Status *",
  "PROGRESS": "Progress",
  "PROGRESS_NOTES": "Progress Notes",
  "PROGRESS_NOTES_DESCRIPTION": "Provide information that can be published to Funders.",
  "PROJECT": "Project",
  "PROJECT_ADDED": "{0} Added",
  "PROJECT_ADDED_ACCESSION": " {0} accession",
  "PROJECT_ADDED_ACCESSIONS": " {0} accessions",
  "PROJECT_ADDED_BATCH": " {0} batch",
  "PROJECT_ADDED_BATCHES": " {0} batches",
  "PROJECT_ADDED_DETAILS": "Also added the following to {0} project:",
  "PROJECT_ADDED_PLANTING_SITE": " {0} planting site",
  "PROJECT_ADDED_PLANTING_SITES": " {0} planting sites",
  "PROJECT_AREA": "Project Area",
  "PROJECT_HIGHLIGHT_IMAGE": "Project Highlight Image",
  "PROJECT_ID": "Project ID",
  "PROJECT_IMPACT": "Project Impact",
  "PROJECT_IMPACT_INSTRUCTIONS": "Provide the details of your impact during the reporting period, including key accomplishments and progress toward meeting stated goals and key milestones. In addition to forestry goals, please include jobs created (full-time, part-time, and seasonal), using specific figures disaggregated by gender. (Approximately one page.)",
  "PROJECT_IMPACT_REQUIRED": "Project Impact *",
  "PROJECT_INFORMATION": "Project Information",
  "PROJECT_LEAD": "Project Lead",
  "PROJECT_NAME": "Project Name",
  "PROJECT_NOTES": "Additional Project Information Notes",
  "PROJECT_OBJECTIVES": "Project Objectives",
  "PROJECT_OR_PROJECTS": "Project(s)",
  "PROJECT_OVERVIEW": "Project Overview",
  "PROJECT_PHOTOS": "Project Photos (max. 30)",
  "PROJECT_PROFILE": "Project Profile",
  "PROJECT_SPECIFIC_METRIC": "Project Specific Metric",
  "PROJECT_SPECIFIC_METRIC_SAVED": "Project Specific Metric Saved",
  "PROJECT_SPECIFIC_METRICS": "Project Specific Metrics",
  "PROJECT_SUMMARY": "Project Summary",
  "PROJECT_SUMMARY_INSTRUCTIONS": "Provide a short narrative description of the progress since your previous report. This summary should be written for a general audience and be suitable for publication. (Under 100 words.)",
  "PROJECT_SUMMARY_REQUIRED": "Project Summary *",
  "PROJECT_ZONE_FIGURE": "Project Zone Figure",
  "PROJECTS": "Projects",
  "PROPOSED_PROJECT_BOUNDARIES_ADDED": "Proposed Project Boundaries Added",
  "PROPOSED_PROJECT_BOUNDARY": "Proposed Project Boundary",
  "PROPOSED_RESTORATION_ACTIVITIES": "Proposed Restoration Activities",
  "PUBLISH": "Publish",
  "PUBLISH_METRIC": "Publish Metric",
  "PUBLISH_TO_FUNDER_PORTAL": "Publish to Funder Portal",
  "PURPOSE": "Purpose",
  "PURPOSE_REQUIRED": "Purpose *",
  "PV_BATTERY": "PV Battery",
  "PV_BATTERY_CHARGE": "PV Battery Charge",
  "PV_SYSTEM": "PV system",
  "Q1_TARGET": "Q1 Target",
  "Q2_TARGET": "Q2 Target",
  "Q3_TARGET": "Q3 Target",
  "Q4_TARGET": "Q4 Target",
  "QUALITATIVE": "Qualitative",
  "QUALITATIVE_INFO": "Qualitative Info",
  "QUANTITY": "Quantity",
  "QUANTITY_MUST_BE_GREATER_THAN_OR_EQUAL_TO_ZERO": "Quantity must be greater than or equal to 0",
  "RARE": "Rare",
  "RATIONALE": "Rationale",
  "REACH_OUT_TO_ADMIN_TITLE": "Please reach out to an administrator from your organization.",
  "READY": "Ready",
  "READY_QUANTITY": "Ready Quantity",
  "READY_QUANTITY_AFTER": "Ready Quantity (After)",
  "READY_QUANTITY_BEFORE": "Ready Quantity (Before)",
  "READY_QUANTITY_REMAINING": "Ready Quantity ({0} remaining)",
  "READY_QUANTITY_REQUIRED": "Ready Quantity *",
  "REASON": "Reason",
  "REASSIGN": "Reassign",
  "REASSIGN_SEEDLINGS": "Reassign Seedlings",
  "REASSIGN_SEEDLINGS_DESCRIPTION": "Enter the new subzone, new quantity, and notes for the species you want to reassign seedlings for. The seedlings for rows you leave empty will not be reassigned.",
  "REASSIGNMENT": "Reassignment",
  "REASSIGNMENT_DURATION": "Reassignment Duration",
  "REASSIGNMENT_REQUEST_NO_PLOTS_ADDED": "No plots will be added.",
  "REASSIGNMENT_REQUEST_NO_PLOTS_ADDED_WARNING": "No plots will be added: no plot available for reassignment.",
  "REASSIGNMENT_REQUEST_PLOTS_ADDED": "The following plots will be added: {0}.",
  "REASSIGNMENT_REQUEST_PLOTS_REMOVED": "The following plots will be removed: {0}.",
  "REASSIGNMENT_REQUEST_SENT": "Reassignment Request Sent",
  "REASSIGNMENT_REQUEST_STATUS": "Reassignment Request Status",
  "RECALCITRANT": "Recalcitrant",
  "RECEIVE_EMAIL_NOTIFICATIONS": "Receive Email Notifications",
  "RECEIVED_DATE": "Received Date",
  "RECEIVED_ON": "Received On",
  "RECEIVING_DATE_REQUIRED": "Receiving Date *",
  "RECEIVING_NURSERY_REQUIRED": "Receiving Nursery *",
  "RECOMMENDED": "Recommended",
  "RECORDED_PLANTS": "Recorded Plants",
  "RECORDED_SESSION": "Recorded Session",
  "RECORDED_SESSIONS": "Recorded Sessions",
  "RECORDED_SPECIES": "Recorded Species",
  "RECORDING_DATE": "Recording Date",
  "RECORDING_DATE_ERROR": "This should be later than Start Date",
  "RECORDING_URL": "Recording URL",
  "REFERENCE": "Reference",
  "REFERENCE_DBH": "Cite reference for \"DBH at Maturity.\"",
  "REFERENCE_HEIGHT_AT_MATURITY": "Cite reference for \"Height at Maturity.\"",
  "REFRESH": "Refresh",
  "REFRESH_DATA": "Refresh Data",
  "REFRIGERATOR_1": "Refrigerator 1",
  "REFRIGERATOR_2": "Refrigerator 2",
  "REFRIGERATOR_3": "Refrigerator 3",
  "REGION": "Region",
  "REGION_ANTARCTICA": "Antarctica",
  "REGION_EAST_ASIA_PACIFIC": "East Asia & Pacific",
  "REGION_EUROPE_CENTRAL_ASIA": "Europe & Central Asia",
  "REGION_LATIN_AMERICA_CARIBBEAN": "Latin America & Caribbean",
  "REGION_MIDDLE_EAST_NORTH_AFRICA": "Middle East & North Africa",
  "REGION_NORTH_AMERICA": "North America",
  "REGION_OCEANIA": "Oceania",
  "REGION_SOUTH_ASIA": "South Asia",
  "REGION_SUB_SAHARAN_AFRICA": "Sub-Saharan Africa",
  "REINTRODUCED": "Reintroduced",
  "REINTRODUCED_DESCRIPTION": "Plants that have been transplanted from a nursery, greenhouse, or other location to a restoration site.",
  "REJECT": "Reject",
  "REJECT_ACTION": "Reject...",
  "REJECT_REASON": "Provide a reason for rejecting.",
  "REJECTED": "Rejected",
  "REMAINING": "Remaining",
  "REMAINING_QUANTITY_NOTES_PLACEHOLDER": "Notes required for quantity changes",
  "REMAINING_SEEDS": "Remaining Seeds",
  "REMOVE": "Remove",
  "REMOVE_ACCESS": "Remove Access",
  "REMOVE_ACCESS_MODAL_TEXT": "This action will not remove people from Terraware. It will just remove their Accelerator Console access.",
  "REMOVE_FUNDER": "Remove Funder",
  "REMOVE_FUNDER_MODAL_TEXT": "Are you sure you want to remove {0}? Removing them means they won’t have access to this funding entity's data anymore.",
  "REMOVE_FUNDERS": "Remove Funders",
  "REMOVE_FUNDERS_MODAL_TEXT": "Are you sure you want to remove these funders? Removing them means they won’t have access to this funding entity's data anymore.",
  "REMOVE_ONLY_ONE_ORG_AT_A_TIME": "You may only remove yourself from one organization at a time.",
  "REMOVE_ORGANIZATION": "Remove Organization?",
  "REMOVE_ORGANIZATION_MODAL_TEXT": "Are you sure you want to remove these organizations from the list of Accelerator Participants?",
  "REMOVE_PARTICIPANT": "Remove Participant",
  "REMOVE_PARTICIPANT_CONFIRMATION": "Are you sure you want to remove participant {0}. This cannot be undone.",
  "REMOVE_PEOPLE": "Remove People",
  "REMOVE_PEOPLE_DESC": "Are you sure you want to remove these people? Removing them means they won’t have access to your organization’s data anymore.",
  "REMOVE_PERSON": "Remove Person",
  "REMOVE_PERSON_DESC": "Are you sure you want to remove {0}? Removing them means they won’t have access to your organization’s data anymore.",
  "REMOVE_PROJECT": "Remove Project",
  "REMOVE_SPECIES": "Remove Species",
  "REMOVING_ORG_WARNING": "Removing yourself from {0} means you won’t have access to this organization’s data anymore. Are you sure you want to save your changes?",
  "REPLACE": "Replace",
  "REPLACE_BOUNDARY": "Replace Boundary",
  "REPLACE_FILE": "Replace File...",
  "REPORT": "Report",
  "REPORT_ANNUAL_DETAILS_TITLE": "Additional Project Details (Annual Report)",
  "REPORT_APPROVED": "Report Approved",
  "REPORT_BACK_WARNING": "Please use form controls at bottom of page.",
  "REPORT_CONCURRENT_EDITOR": "Concurrent Editor",
  "REPORT_CONCURRENT_EDITOR_WARNING_1": "There is someone else editing this report ({0}).",
  "REPORT_CONCURRENT_EDITOR_WARNING_2": "By continuing to edit this report, their changes will be discarded. Are you sure you want to continue?",
  "REPORT_CONFIRM_SUBMIT": "Are you sure you wish to submit this report? This action cannot be undone.",
  "REPORT_COULD_NOT_EDIT": "Could not edit report",
  "REPORT_COULD_NOT_OPEN": "Could not open report",
  "REPORT_COULD_NOT_SAVE": "Could not save report",
  "REPORT_COULD_NOT_SUBMIT": "Could not submit report",
  "REPORT_COULD_NOT_UNLOCK": "Could not unlock report",
  "REPORT_EDIT": "Edit Report",
  "REPORT_MORTALITY_RATE_INFO": "If known please list the death rates of all planted trees and other plants as a percentage. If unknown please enter 0.",
  "REPORT_NAME": "Report Name",
  "REPORT_NEEDS_UPDATE": "Report Needs Update",
  "REPORT_NO_NURSERIES": "No nurseries included in report.",
  "REPORT_NO_PLANTING_SITES": "No planting sites included in report.",
  "REPORT_NO_SEEDBANKS": "No seed banks included in report.",
  "REPORT_NURSERY_CAPACITY_INFO": "Please list the total number of plants that the nursery can hold using best estimates.",
  "REPORT_PERIOD": "Report Period: {0} - {1}",
  "REPORT_PROBLEM": "Report Problem",
  "REPORT_PUBLISHED": "Report Published",
  "REPORT_SAVE_AND_CLOSE": "Save and Close",
  "REPORT_SEEDBANK_BUILD_COMPLETION_DATE": "Seed Bank Build Completion Date *",
  "REPORT_SEEDBANK_BUILD_START_DATE": "Seed Bank Build Start Date *",
  "REPORT_SEEDBANK_OPERATION_START_DATE": "Seed Bank Operation Start Date *",
  "REPORT_SUBMIT": "Submit Report",
  "REPORT_SUBMITTED_FOR_APPROVAL": "Report Submitted for Approval",
  "REPORT_SUMMARY_OF_PROGRESS_INFO": "Give a brief summary of progress including advancement toward meeting restoration targets as well as social and community benefits in the project.",
  "REPORT_TOTAL_NON_TREES_PLANTED_INFO": "Please include all other plants planted that are affiliated with the Terraformation project; do not include trees in this figure.",
  "REPORT_TOTAL_PAID_WORKERS_INFO": "Please list the total number of full-time or part-time paid workers engaged in planting in this project.",
  "REPORT_TOTAL_PLANTED_AREA_INFO": "Please list the total number of hectares already planted during the current lifespan of this project.",
  "REPORT_TOTAL_PLANTING_SITE_AREA_INFO": "Please list your total project area in hectares. If your project with Terraformation does not include land dedicated to restoration enter 0.",
  "REPORT_TOTAL_TREES_PLANTED_INFO": "Please include all trees planted that are affiliated with the Terraformation project; do not include non-trees such as shrubs in this figure.",
  "REPORT_TOTAL_VOLUNTEERS_INFO": "Please list the total number of volunteers engaged in planting in this project. If none write 0.",
  "REPORT_TOTAL_WOMEN_PAID_WORKERS_INFO": "Of the total workers listed above how many total are women?",
  "REPORT_VIEW_ANNUAL": "View Annual Report",
  "REPORT_VIEW_QUARTERLY": "View Quarterly Report",
  "REPORTED_PLANTS_PER_SPECIES_CARD_TITLE": "What is the reported number of plants planted per species?",
  "REPORTS": "Reports",
  "REPORTS_PRE_SETUP_SUBTITLE": "Reports are generated every quarter (3 months) so we can review your progress. You can submit reports at the organization level, at the project level, or both.",
  "REPORTS_PRE_SETUP_SUBTITLE_2": "Go to reports settings to set up which reports get generated.",
  "REPORTS_SETTINGS": "Reports Settings",
  "REPORTS_SETTINGS_EDIT_SUBTITLE": "Reports can be generated at the organization level, at the project level, or both. Select the projects you'd like reports for.",
  "REPORTS_SETTINGS_GENERATE_FOR_ORG": "Generate Report for {0}",
  "REPORTS_SETTINGS_GENERATE_FOR_PROJECT": "Generate Project Report for",
  "REPORTS_SETUP_CTA": "Set Up Reports",
  "REQUEST_FEATURE": "Request Feature",
  "REQUEST_REASSIGNMENT": "Request Reassignment",
  "REQUEST_REASSIGNMENT_JUSTIFICATION": "Provide a reason for requesting a reassignment of this plot’s location.",
  "REQUEST_UPDATE": "Request Update",
  "REQUEST_UPDATE_ACTION": "Request Update...",
  "REQUEST_UPDATE_REASON": "Provide a reason for requesting update.",
  "REQUIRED": "Required",
  "REQUIRED_FIELD": "Required field",
  "REQUIRED_QUESTION_MARK": "Required?",
  "RESCHEDULE": "Reschedule",
  "RESCHEDULE_OBSERVATION": "Reschedule Observation",
  "RESET": "Reset",
  "RESET_METRIC": "Reset Metric",
  "RESET_METRIC_CONFIRM": "Are you sure you want to reset this metric? It will be replaced with current tracking data from Terraware.",
  "RESET_STATUS": "Reset Status",
  "RESET_STATUS_BODY": "Adding this species to the selected project(s) will reset the deliverable status. You will need to resubmit the deliverable for approval for: {0}",
  "RESPONSIVENESS_AND_ATTENTION_TO_DETAIL": "Responsiveness and Attention to Detail",
  "RESTART_PRESCREEN": "Restart Pre-screen",
  "RESTART_PRESCREEN_CONFIRMATION": "You are about to restart your Pre-screen.",
  "RESTORABLE_LAND": "Restorable Land",
  "REVIEW": "Review",
  "REVIEW_AND_SUBMIT": "Review & Submit",
  "REVIEW_APPLICATION": "Review Application",
  "REVIEW_APPLICATION_COMPLETE": "Please review all of your questions before submitting your Application to our Accelerator Team.",
  "REVIEW_APPLICATION_INCOMPLETE": "You must complete all sections before you are able to submit your Application to our Accelerator Team.",
  "REVIEW_APPLICATION_STATUS_TEXT": "Requirements for {0} are {1}",
  "REVIEW_ERRORS": "Review Errors",
  "REVIEW_YOUR_ACCOUNT_SETTING": "Review your account setting",
  "REVIEW_YOUR_APPLICATION": "Review your application",
  "REVIEW_YOUR_ORGANIZATION_SETTING": "Review your organization setting",
  "ROLE": "Role",
  "ROLE_REQUIRED": "Role *",
  "ROLES_INFO": "Select a role for this person.",
  "ROUNDED_INFO": "Rounded to the nearest thousandth.",
  "ROWS_SELECTED": "{0} selected",
  "RUN_A_DATABASE_CHECK": "Run a Database Check",
  "SALINITY_PPT": "Salinity (ppt)",
  "SAMPLE_OBSERVED_DENSITY_WARNING": "This calculation is based on a sample from less than an entire site. Samples from less than the entire site may lead to misleading results.",
  "SAND": "Sand",
  "SAND_PETRI_DISH": "Sand Petri Dish",
  "SATELLITE": "Satellite",
  "SAVE": "Save",
  "SAVE_AND_CLOSE": "Save and Close",
  "SAVE_AND_NEXT": "Save and Next",
  "SAVE_ANYWAY": "Save Anyway",
  "SAVE_CHANGES": "Save Changes",
  "SAVE_PROJECT_BOUNDARIES": "Save Project Boundaries",
  "SAVE_VERSION": "Save Version",
  "SAVE_VERSION_ELLIPSIS": "Save Version...",
  "SAVE_VERSION_MESSAGE": "Saving a version is the equivalent of creating a screenshot of what the Document looks like in its current state. You can continue to edit the document but you may not edit the saved version.",
  "SAVED": "Saved",
  "SCARIFY": "Scarify",
  "SCHEDULE_OBSERVATION": "Schedule Observation",
  "SCHEDULE_OBSERVATION_MESSAGE": "Select the zones and subzones to include in observation:",
  "SCHEDULED": "(Scheduled)",
  "SCIENTIFIC_NAME": "Scientific Name",
  "SCIENTIFIC_NAME_NOT_FOUND": "“{0}” was not found in our database, but you can still add it.",
  "SCIENTIFIC_NAME_REQUIRED": "Scientific Name *",
  "SCORE": "Score",
  "SCORE_DETAILS_LINK": "Score Details Link",
  "SCORE_SUMMARY": "Score Summary",
  "SCORE_VALUE_0": "0 Neutral",
  "SCORE_VALUE_N1": "-1 negative, but issues can be overcome",
  "SCORE_VALUE_N2": "-2 negative, but issues cannot be overcome",
  "SCORE_VALUE_NULL": "No score selected",
  "SCORE_VALUE_P1": "1+ Postive",
  "SCORE_VALUE_P2": "2+ Very Positive",
  "SCORES": "Scores",
  "SCORING_COMPLETED": "Scoring completed",
  "SCORING_NOT_COMPLETED": "Scoring not completed",
  "SDG_01": "1. No Poverty",
  "SDG_02": "2. Zero Hunger",
  "SDG_03": "3. Good Health and Well-Being",
  "SDG_04": "4. Quality Education",
  "SDG_05": "5. Gender Equality",
  "SDG_06": "6. Clean Water and Sanitation",
  "SDG_07": "7. Affordable and Clean Energy",
  "SDG_08": "8. Decent Work and Economic Growth",
  "SDG_09": "9. Industry, Innovation, and Infrastructure",
  "SDG_10": "10. Reduced Inequalities",
  "SDG_11": "11. Sustainable Cities and Communities",
  "SDG_12": "12. Responsible Consumption and Production",
  "SDG_13": "13. Climate Action",
  "SDG_14": "14. Life Below Water",
  "SDG_15": "15. Life on Land",
  "SDG_16": "16. Peace, Justice, and Strong Institutions.",
  "SDG_17": "17. Partnerships for the Goals",
  "SEARCH": "Search",
  "SEARCH_BY_NAME_OR_FAMILY": "Search by name or family...",
  "SEARCH_OR_SELECT": "Search or Select...",
  "SECTION_OWNER_ASSIGNED": "Section Owner Assigned",
  "SECTIONS_USED": "Sections Used",
  "SEE_ALL_ACCESSIONS": "See All Accessions",
  "SEE_ALL_MODULES": "See All Modules",
  "SEE_IC_VOTES": "See IC Votes",
  "SEE_PROJECT_DETAILS": "See Project Details",
  "SEE_SCORECARD": "See Scorecard",
  "SEE_WITHDRAWAL_HISTORY": "See Withdrawal History",
  "SEED": "Seed",
  "SEED_BANK": "Seed Bank",
  "SEED_BANK_ADDED": "Seed Bank added.",
  "SEED_BANK_INTERNET": "Seed Bank Internet",
  "SEED_BANK_NOTES": "Additional Seed Bank Notes",
  "SEED_BANKS": "Seed Banks",
  "SEED_BANKS_CARD_DESCRIPTION": "How do you process and store your seeds? Add seed banks to your organization.",
  "SEED_COLLECTION": "Seed Collection",
  "SEED_COLLECTION_DETAIL": "Seed Details",
  "SEED_COLLECTION_DETAIL_DESC": "Enter this accession’s seed information below.",
  "SEED_COUNT": "Seed Count",
  "SEED_DASHBOARD": "Seed Dashboard",
  "SEED_FUND_REPORTS": "Seed Fund Reports",
  "SEED_PRODUCTION": "Seed Production",
  "SEED_QUANTITY_BY": "Seed Quantity By",
  "SEED_STORAGE_BEHAVIOR": "Seed Storage Behavior",
  "SEED_TYPE": "Seed Type",
  "SEED_WEIGHT": "Seed Weight",
  "SEEDLING_BATCH": "Seedling Batch",
  "SEEDLINGS": "Seedlings",
  "SEEDLINGS_BATCHES": "Seedlings Batches",
  "SEEDLINGS_PLURAL": "seedlings",
  "SEEDLINGS_SENT": "Seedlings Sent",
  "SEEDLINGS_SINGULAR": "seedling",
  "SEEDS": "Seeds",
  "SEEDS_GERMINATED": "Seeds Germinated",
  "SELECT": "Select...",
  "SELECT_ACCESSIONS_FOR_PROJECT": "Select Accessions for {0}",
  "SELECT_ACCESSIONS_FOR_PROJECT_DESCRIPTION": "Use the checkbox column to select accessions that you’d like to add to {0}.",
  "SELECT_ALL": "Select All",
  "SELECT_AT_LEAST_ONE_SUBZONE": "Select at least one subzone",
  "SELECT_BATCHES": "Select Batches",
  "SELECT_BUTTON": "Select",
  "SELECT_EXISTING_PROJECT": "Select Existing Project",
  "SELECT_PLANTING_SITE_TYPE": "Select Planting Site Type",
  "SELECT_PLANTING_SITE_TYPE_DESCRIPTION_1": "Please select which type of planting site to add.",
  "SELECT_PLANTING_SITE_TYPE_DESCRIPTION_2": "Detailed sites allow you to track the location of plants within the site and perform live/dead monitoring. Simple sites allow you to track how many and which species of plants have been planted on the site.",
  "SELECT_PLANTING_SITE_TYPE_DESCRIPTION_3": "Please note that if you create a simple site, you won’t be able to change it to a detailed site later on.",
  "SELECT_PLANTING_SITES_FOR_PROJECT": "Select Planting Sites for {0}",
  "SELECT_PLANTING_SITES_FOR_PROJECT_DESCRIPTION": "Use the checkbox column to select planting sites that should be added to {0}.",
  "SELECT_PROJECT": "Select Project",
  "SELECT_SEED_BANK": "Select Seed Bank",
  "SELECT_SEED_BANK_INFO": "Accessions require a seed bank storage location. Please select a seed bank.",
  "SELECT_SEEDLINGS_BATCHES_FOR_PROJECT": "Select Seedling Batches for {0}",
  "SELECT_SEEDLINGS_BATCHES_FOR_PROJECT_DESCRIPTION": "Use the checkbox column to select seedling batches that should be added to {0}.",
  "SELECT_VOTE": "Select Vote",
  "SELECTED_SPECIES_IN_USE": "Selected species are all in use and cannot be deleted.",
  "SELECTED_SPECIES_UNUSED": "Selected species are not in use and can be deleted.",
  "SEND": "Send",
  "SEND_REQUEST": "Send Request",
  "SENSITIVE_QUESTION_MARK": "Sensitive?",
  "SENSOR_KIT": "Sensor Kit",
  "SENSOR_KIT_ID_PLACEHOLDER": "XXXXXX",
  "SENSOR_KIT_SET_UP_COMPLETE": "Setup Complete!",
  "SENSOR_KIT_SET_UP_COMPLETE_DESCRIPTION": "You will now be able to view solar battery charge and sensor data in your sensor monitoring dashboard.",
  "SENSOR_KIT_SET_UP_DESCRIPTION": "If your seed bank has a sensor kit, let's set it up below.",
  "SENSOR_KIT_SET_UP_DETECT_SENSORS": "Detect Sensors",
  "SENSOR_KIT_SET_UP_DETECT_SENSORS_DESCRIPTION": "To power on sensors, remove the paper tabs blocking the batteries. When sensors are powered on and within range, they'll be detected by the device manager automatically.",
  "SENSOR_KIT_SET_UP_DEVICE_MANAGER": "Install Device Manager Update",
  "SENSOR_KIT_SET_UP_DEVICE_MANAGER_DESCRIPTION": "To detect your sensors, the device manager in your sensor kit needs to download the latest code; this may take up to 20 minutes. The download starts the moment your sensor kit is connected to the internet, so this step might alread be complete.",
  "SENSOR_KIT_SET_UP_PV_SYSTEM": "Select PV System",
  "SENSOR_KIT_SET_UP_PV_SYSTEM_DESCRIPTION": "Our seed banks support multiple types of PV systems; select which one you have so that we can accurately display battery charge.",
  "SENSOR_KIT_SET_UP_SENSOR_KIT_ID": "Enter Sensor Kit ID",
  "SENSOR_KIT_SET_UP_SENSOR_KIT_ID_DESCRIPTION": "Find your sensor kit ID on the outside of your sensor kit. This will connect the Device Manager inside the kit to our database.",
  "SENSOR_KIT_SET_UP_SENSOR_LOCATIONS": "Assign Sensor Locations",
  "SENSOR_KIT_SET_UP_SENSOR_LOCATIONS_DESCRIPTION": "Your sensor kit includes 14 temperature/humidity sensors. Please put one sensor in each location. Select which sensor you put in each location using the dropdown.",
  "SENSOR_KIT_SET_UP_TIME": "This may take up to 30 minutes.",
  "SENSOR_KIT_SET_UP_TITLE": "Let's Set Up Your Sensor Kit!",
  "SENSOR_LOCATION_ERROR": "Each location much have one sensor assigned to it.",
  "SENSOR_SCAN_TIMEOUT": "Sensor Scan Timeout",
  "SENSOR_SCAN_TIMEOUT_ERROR": "Only {0}/{1} sensors were found. Please make sure all sensors are powered on and within range, then try again. If this problem persists, you might have broken sensors; if you think that's the case, email us at {2}.",
  "SENSORS_FOUND": "{0}/{1} sensors found...",
  "SERVER_ERROR": "Server Error",
  "SESSION_HAS_ENDED": "Session has ended.",
  "SESSION_HAS_NOT_STARTED": "Session has not started.",
  "SESSION_IS_IN_PROGRESS": "Session is in progress.",
  "SESSION_IS_STARTING_SOON": "Session is starting soon.",
  "SESSION_SLIDES": "Session Slides",
  "SET_PLANTING_COMPLETE": "Planting Complete",
  "SET_REMINDER": "Set Reminder",
  "SET_UP": "Set Up",
  "SET_UP_NURSERY": "Set up Nursery",
  "SET_UP_SEED_BANK": "Set up Seed Bank",
  "SET_UP_YOUR_SENSOR_KIT": "Set Up Your Sensor Kit",
  "SET_UP_YOUR_SENSOR_KIT_MSG": "If your seed bank was built by Terraformation, it is equipped with a sensor kit that you can remotely monitor things like the seed bank's temperature and humidity. To set this up, you'll need to connect your seed bank to the Terraware web app. This may take up to 30 minutes.",
  "SETTINGS": "Settings",
  "SHRUB": "Shrub",
  "SHRUB_TREE": "Shrub or Tree",
  "SHRUBS": "Shrubs",
  "SILVOPASTURE": "Silvopasture",
  "SIMPLE_SITE": "Simple Site",
  "SINGLE_SPECIES_MORTALITY_RATE_MESSAGE": "You have only 1 species with a mortality rate right now. Once there are more, the species with the lowest mortality rate will appear.",
  "SINGLE_ZONE_MORTALITY_RATE_MESSAGE": "You have only 1 zone with a mortality rate right now. Once there are more, the zone with the lowest mortality rate will appear.",
  "SITE": "Site",
  "SITE_BOUNDARY": "Site Boundary",
  "SITE_BOUNDARY_ABSENT_WARNING": "Please draw a site boundary.",
  "SITE_BOUNDARY_DESCRIPTION_0": "Draw the site boundary of your planting site below. All plantable areas within your project must be contained within the site boundary.",
  "SITE_BOUNDARY_DESCRIPTION_1": "Use the drawing tool {0} to draw the boundary of the planting site. [Watch a tutorial] about drawing site boundaries.",
  "SITE_BOUNDARY_DESCRIPTION_2": "The site boundary should fit in a bounding box of less than or equal to 20,000 hectares. If it is larger, consider splitting the site into multiple planting sites.",
  "SITE_BOUNDARY_DESCRIPTION_3": "Zoom in to the location of the planting site. Then click on areas of the map to add points for the site boundary. Complete the boundary by either double-clicking or by clicking on the starting point again.",
  "SITE_BOUNDARY_DESCRIPTION_4": "To change the site boundary shape, click on the shape to change the points. To remove the shape, click the {0} button.",
  "SITE_BOUNDARY_DESCRIPTION_WARN": "The boundary should fit in a bounding box of less than or equal to 20000 hectares, otherwise consider splitting the site into multiple planting sites.",
  "SITE_BOUNDARY_ERRORS": "There are errors in the site boundary.",
  "SITE_BOUNDARY_POLYGON_TOO_LARGE": "Boundary with area {0} hectares exceeds {1} hectares.",
  "SITE_BOUNDARY_POLYGON_TOO_SMALL": "Boundary with area {0} hectares is smaller than 100m x 100m.",
  "SITE_BOUNDARY_SIMPLE_SITE_NOTE": "Note: By default, Simple Sites will include only one Zone and one Subzone that comprise the entire planting site.",
  "SITE_BOUNDING_AREA_TOO_LARGE": "Bounding area {0} hectares is too large.",
  "SITE_DETAIL": "Site Detail",
  "SITE_EDIT_DISABLED_TOOLTIP": "Planting site is currently a draft - only the site’s creator can edit.",
  "SITE_EDITOR_USE_DESKTOP": "This feature is only available from the desktop application.",
  "SITE_EXCLUSION_AREAS_DESCRIPTION_0": "Areas within the site boundary that are not plantable should be excluded. These exclusion areas will be removed from plantable area calculations and will not be monitored as a part of routine site observation. Example locations that should be excluded include roads, bodies of water, and outbuildings.",
  "SITE_EXCLUSION_AREAS_DESCRIPTION_1": "Draw the boundaries of the exclusion areas of the planting site below. Use the drawing tool {0} to draw the exclusion areas of the planting site. [Watch a tutorial] about drawing exclusion areas. Skip this step if there are no areas to exclude.",
  "SITE_EXCLUSION_AREAS_DESCRIPTION_2": "Exclude areas of the planting site by drawing shapes within or overlapping the planting site boundary. Complete the exclusion area shapes by either double-clicking or by clicking on the starting point again.",
  "SITE_EXCLUSION_AREAS_OPTIONAL": "Exclusion Areas (Optional)",
  "SITE_EXCLUSION_ERRORS": "There are errors in the exclusion boundary.",
  "SITE_LOCATION": "Site Location",
  "SITE_MAP": "Site Map",
  "SITE_SUBZONE_BOUNDARIES": "Subzone Boundaries",
  "SITE_SUBZONE_BOUNDARIES_DESCRIPTION_0": "Each Zone of your planting site is divided into one or more Subzones. A Subzone is the smallest area to which seedlings can be allocated during planting. Subzones should be sized such that the entirety of the Subzone can be planted during a single planting season. Subzones are generally 50-200 hectares.",
  "SITE_SUBZONE_BOUNDARIES_DESCRIPTION_1": "Draw the Subzones of your planting site below. First, select a Zone in which to create Subzones. Use the slice tool {0} to create Subzone shapes (polygons) within the Zones. [Watch a tutorial] about adding Subzone boundaries.",
  "SITE_SUBZONE_BOUNDARIES_SELECT_A_ZONE": "Select a zone to create Subzones.",
  "SITE_SUBZONE_BOUNDARIES_SELECTED_ZONE": "Zone {0} is currently selected for creating Subzones.",
  "SITE_SUBZONE_BOUNDARIES_TOO_SMALL": "One or more Subzones have a boundary smaller than 25m x 25m",
  "SITE_SUBZONE_BOUNDARY_TOO_SMALL": "Subzone boundary smaller than 25m x 25m",
  "SITE_WITH_NAME_EXISTS": "Site with this name already exists.",
  "SITE_ZONE_BOUNDARIES": "Zone Boundaries",
  "SITE_ZONE_BOUNDARIES_DESCRIPTION_0": "A Zone is a stratum (vegetation layer) of the planting site where planting and growing conditions are similar. Each planting site must have at least one zone and usually no more than five. An example of a Zone is the slope of an east-facing hill, where sunlight and soil conditions are similar.",
  "SITE_ZONE_BOUNDARIES_DESCRIPTION_1": "Draw the Zones of your planting site below. Use the slice tool {0} to create polygons within the site boundaries for Zones. [Watch a tutorial] about adding Zone boundaries.",
  "SITE_ZONE_BOUNDARIES_SIZE": "Zones should have a minimum size of 100m x 100m.",
  "SITE_ZONE_BOUNDARIES_TOO_SMALL": "One or more zones have a boundary smaller than 100m x 100m",
  "SITE_ZONE_BOUNDARY_TOO_SMALL": "Zone boundary smaller than 100m x 100m",
  "SITE_ZONE_NAMES_MISSING": "On or more zones are missing names. Click on a zone to edit its name.",
  "SKIP": "Skip",
  "SLIDES_URL": "Slides URL",
  "SOAK": "Soak",
  "SOCIAL_IMPACT": "Social Impact",
  "SOCIAL_IMPACT_INSTRUCTIONS": "List the direct benefits of the project to the local community. Specific benefits may include the impact on livelihoods; community education and training; access to safe water; support to youth, women, and/or minority groups; and other socioeconomic and community benefits of the project. Please include the specific indicators you are using to measure community impact and the results you have monitored over time. (One-half page maximum.)",
  "SOCIAL_IMPACT_REQUIRED": "Social Impact and Community Benefits *",
  "SOIL": "Soil",
  "SOIL_PHOTO": "Soil Photo",
  "SOMETHING_WENT_WRONG": "Something went wrong.",
  "SOMETHING_WENT_WRONG_MESSAGE": "If you’re having trouble using Terraware, please report any issues you’re having and we’ll make it right.",
  "SOMETHING_WENT_WRONG_TITLE": "Something went wrong...",
  "SOURCING": "Sourcing",
  "SPECIES": "Species",
  "SPECIES_APPROVED": "Species Approved",
  "SPECIES_CARD_DESCRIPTION": "View the Species that are referenced by your Seed and Plant entries.",
  "SPECIES_CATEGORIES": "Species Categories",
  "SPECIES_CATEGORIES_NUMBER": "Species Categories ({0})",
  "SPECIES_CATEGORIES_TOOLTIP": "Species Categories shows the percentage of total plants planted that are Rare and Endangered, based on the species.",
  "SPECIES_DESCRIPTION": "Manage your organization’s species list for planning, operation and reporting.",
  "SPECIES_EMPTY_MSG_BODY": "Enter species that you collect or plant now to simplify your experience when you’re out in the field.",
  "SPECIES_IMPORT_COMPLETE": "Species data import complete!",
  "SPECIES_LAST_UPDATED": "Species Last Updated",
  "SPECIES_LIST": "Species List",
  "SPECIES_LIST_DELIVERABLE_ADD_SPECIES_ACTIVE_DELIVERABLE_INFO": "Adding this species to this project will reset the status of your active species deliverable. You will need to resubmit the deliverable for approval.",
  "SPECIES_LIST_DELIVERABLE_ADD_SPECIES_RECENT_DELIVERABLE_INFO": "Adding this species to this project will reset the status of your most recent species deliverable. You will need to resubmit the deliverable for approval.",
  "SPECIES_LIST_NO_ORGANIZATION_SPECIES_BODY": "Go to \"Species\" and add species to your organization in order to select them for this project. You can find more detailed instructions on our [Knowledge Base].",
  "SPECIES_LIST_NO_ORGANIZATION_SPECIES_TITLE": "No Species for Organization",
  "SPECIES_MATCHED": "Species Matched",
  "SPECIES_MORTALITY": "Species Mortality",
  "SPECIES_MORTALITY_TOOLTIP": "Species Mortality shows the species with the highest and lowest mortality rates, among the zones that were observed.",
  "SPECIES_NAME": "Species Name",
  "SPECIES_NOT_ACCEPTED": "Species Not Accepted",
  "SPECIES_OBSERVED": "Species Observed",
  "SPECIES_PROBLEM_NAME_IS_SYNONYM": "Name Is Synonym",
  "SPECIES_PROBLEM_NAME_MISSPELLED": "Name Misspelled",
  "SPECIES_PROBLEM_NAME_NOT_FOUND": "Name Not Found",
  "SPECIES_REQUIRED": "Species *",
  "SPECIES_SELECTED": "Species Selected",
  "SPECIES_USAGE": "Species Usage",
  "STAFF": "Staff",
  "STAKEHOLDERS_AND_COMMUNITY_IMPACT": "Stakeholders and Community Impact",
  "STANDARD_DEVIATION": "Standard Deviation",
  "STANDARD_METRICS": "Standard Metrics",
  "START": "Start",
  "START_DATE": "Start Date",
  "START_DATE_REQUIRED": "Start Date *",
  "START_NEW_APPLICATION": "Start New Application",
  "START_OVER": "Start Over",
  "START_OVER_CONFIRMATION": "Are you sure?",
  "START_OVER_WARNING": "Site boundary, exclusion area, zone and subzone boundaries will be cleared, and you will need to provide the information again.",
  "START_TIME": "Start Time",
  "STARTED": "Started: {0}",
  "STATE": "State",
  "STATE_PROVINCE_REGION": "State/Province/Region",
  "STATE_REQUIRED": "State *",
  "STATS_WARNING_DESCRIPTION_1": "Observation statistics were calculated after this subzone was marked as Planting Complete.",
  "STATS_WARNING_DESCRIPTION_2": "Undoing the Planting Complete status will delete those statistics. Are you sure you want to undo?",
  "STATUS": "Status",
  "STATUS_WITH_STATUS": "Status: {0}",
  "STORAGE": "Storage",
  "STORED": "Stored",
  "STORING": "Storing",
  "STRATIFICATION": "Stratification",
  "SUB_LOCATION": "Sub-Location",
  "SUB_LOCATION_DETAILS": "Sub-Location Details",
  "SUB_LOCATION_EXISTS": "This sub-location already exists",
  "SUB_LOCATIONS": "Sub-Locations",
  "SUBMIT": "Submit",
  "SUBMIT_ACCELERATOR_REPORT_MESSAGE": "Are you sure you want to submit this report for approval? You will not be able to undo this action.",
  "SUBMIT_APPLICATION": "Submit Application",
  "SUBMIT_DOCUMENT": "Submit Document",
  "SUBMIT_FOR_APPROVAL": "Submit for Approval",
  "SUBMIT_PRESCREEN": "Submit Pre-screen",
  "SUBMIT_PRESCREEN_CONFIRMATION": "You are about to submit your Pre-screen.",
  "SUBMIT_QUESTIONNAIRE_CONFIRMATION": "Are you sure you want to submit this questionnaire for approval?",
  "SUBMIT_SPECIES_CONFIRMATION": "Are you sure you want to submit this species list for approval?",
  "SUBMITTED": "Submitted",
  "SUBMITTED_BY": "Submitted By",
  "SUBSET_COUNT": "Subset Count",
  "SUBSET_WEIGHT": "Subset Weight",
  "SUBSET_WEIGHT_ERROR": "Subset weight should be less than seed weight",
  "SUBSET_WEIGHT_POSITIVE": "Subset weight should be a positive number",
  "SUBSET_WEIGHT_REQUIRED": "You must enter in a subset weight and count in order to determine approximate seed count when withdrawing to a nursery. This can be done by editing the quantity of this accession.",
  "SUBSHRUB": "Subshrub",
  "SUBSTRATE": "Substrate",
  "SUBSTRATE_AFTER": "Substrate (After)",
  "SUBSTRATE_BEFORE": "Substrate (Before)",
  "SUBSTRATE_NOTES": "Substrate Notes",
  "SUBTITLE_APPLICATION_GET_STARTED": "To get started, please create your Organization now. Once you create your Organization you will be asked to fill out a pre-screen form to determine your project's eligibility.",
  "SUBTITLE_GET_STARTED": "To get started, please create your organization now. You'll be able to set up and manage your organization’s people, species list, locations, and projects.",
  "SUBZONE": "Subzone",
  "SUBZONE_BOUNDARIES": "Subzone Boundaries",
  "SUBZONE_NAME_IN_USE": "Subzone name is already in use.",
  "SUBZONE_PLANTING_COMPLETED_SUCCESS": "Subzone(s) marked as Planting Complete.",
  "SUBZONE_PLANTING_UNCOMPLETED_SUCCESS": "Subzone(s) marked as Planting Incomplete.",
  "SUBZONE_REQUIRED": "Subzone *",
  "SUBZONES": "Subzones",
  "SUCCESS": "Success",
  "SUCCESS_STORIES": "Success Stories",
  "SUCCESS_STORIES_INSTRUCTIONS": "Provide a concise narrative of one to two personalized success stories. (One-half page maximum.)",
  "SUCCESS_STORIES_REQUIRED": "Success Stories *",
  "SUCCESSIONAL_GROUP": "Successional Group",
  "SUCCESSIONAL_GROUP_EARLY_SECONDARY": "Early Secondary",
  "SUCCESSIONAL_GROUP_LATE_SECONDARY": "Late Secondary",
  "SUCCESSIONAL_GROUP_MATURE": "Mature",
  "SUCCESSIONAL_GROUP_PIONEER": "Pioneer",
  "SUGGESTION": "Suggestion",
  "SUMMARY": "Summary",
  "SUMMARY_OF_PROGRESS": "Summary of Progress",
  "SUMMARY_OF_PROGRESS_DESCRIPTION": "Give a brief summary of this project.",
  "SUMMARY_OF_PROGRESS_REQUIRED": "Summary of Progress *",
  "SUPPLEMENTAL_FILES": "Supplemental Files",
  "SUSTAINABLE_DEVELOPMENT_GOALS": "Sustainable Development Goals",
  "SUSTAINABLE_TIMBER": "Sustainable Timber",
  "SYSTEM_METRICS": "System Metrics",
  "TABLE_OF_CONTENTS": "Table of Contents",
  "TABLE_SELECT_ALL_ROWS": "Select all {0} rows.",
  "TABLE_SELECT_NONE": "Clear selection.",
  "TABLE_SELECTED_ROW": "{0} row selected.",
  "TABLE_SELECTED_ROW_ACROSS_PAGES": "{0} row selected across {1} pages.",
  "TABLE_SELECTED_ROWS": "{0} rows selected.",
  "TABLE_SELECTED_ROWS_ACROSS_PAGES": "{0} rows selected across {1} pages.",
  "TABLE_UPDATED": "Table updated",
  "TAKE_ME_THERE": "Take Me There",
  "TARGET": "Target",
  "TARGET_DENSITY": "Target Density",
  "TARGET_DENSITY_PLANTS_PER_HECTARE": "Target: {0} Plants/ha",
  "TARGET_DENSITY_TOOLTIP": "Target density is the target number of plants per hectare for the zone, which was provided by the admin who manages the planting site.",
  "TARGET_HECTARES_PLANTED": "Target: {0} Hectares",
  "TARGET_PLANTING_DENSITY": "Target Planting Density",
  "TARGET_PLANTING_DENSITY_TOOLTIP": "Target planting density for zone (plants per hectare).",
  "TARGET_VS_OBSERVED_DENSITY": "Target vs. Observed Density",
  "TARGETS": "Targets",
  "TEMPERATURE_AND_HUMIDITY_SENSOR_DATA": "Temperature & Humidity Sensor Data",
  "TEMPLATE": "Template",
  "TEMPLATES": "Templates",
  "TEMPORARY": "Temporary",
  "TERRAFORMATION_CONTACT": "Terraformation Contact",
  "TERRAWARE_IS_SOFTWARE": "Terraware is specialized software, created by [Terraformation], that enables foresters to optimize any stage of their forestry projects, from seed collection to carbon calculation.",
  "TERRAWARE_METRIC_MESSAGE": "This metric is taken directly from tracking data in Terraware.",
  "TERRAWARE_MOBILE_APP_IMAGE_ALT": "Illustration of the Terraware mobile app on a smartphone.",
  "TEST": "Test",
  "TEST_DATE_REQUIRED": "Test Date *",
  "TEST_METHOD": "Test Method",
  "TEST_METHOD_REQUIRED": "Test Method *",
  "TEST_TYPE": "Test Type",
  "TESTING_STAFF": "Testing Staff",
  "TEXT_REQUIRED_BOTH_FIELDS": "Text is required for both fields.",
  "THANK_YOU_FOR_CONTACTING_SUPPORT": "Thank you for contacting Terraware Support. Your request has been received. Your request ID is {0}.",
  "THANK_YOU_FOR_USING_TERRAWARE": "Thank you for using Terraware!",
  "THERE_ARE_NO_SPECIES_ADDED_TO_THIS_PROJET_YET": "There are no species added to this Project yet.",
  "THIS_ACTION_IS_NON_REVERSIBLE": "This action is non-reversible.",
  "THIS_DELIVERABLE_HAS_BEEN_APPROVED": "This deliverable has been approved. The list of species and their status may change as subsequent species list deliverables are submitted.",
  "THIS_MODULE_CONTAINS": "This module contains:",
  "THIS_OBSERVATION_INCLUDES": "This observation includes the following subzones:",
  "THIS_REPORT_HAS_BEEN_APPROVED": "This report has been approved.",
  "THREATENED": "Threatened",
  "TIDE": "Tide",
  "TIME": "Time",
  "TIME_PERIOD": "Time Period",
  "TIME_ZONE": "Time Zone",
  "TIME_ZONE_REQUIRED": "Time Zone *",
  "TIME_ZONE_SELECTED": "Time zone: {0}",
  "TITLE": "Title",
  "TITLE_OVERVIEW": "{0} Overview",
  "TITLE_REPORT_PROBLEM": "Report a Problem",
  "TITLE_REQUEST_FEATURE": "Request a Feature",
  "TITLE_WELCOME": "Welcome to Terraware",
  "TITLE_WELCOME_EXCLAIM": "Welcome to Terraware!",
  "TO": "To",
  "TO_NURSERY": "To: Nursery",
  "TO_NURSERY_REQUIRED": "To: Nursery *",
  "TO_PLANTING_SITE_REQUIRED": "To: Planting Site *",
  "TO_SUBZONE": "To: Subzone",
  "TODO": "To Do",
  "TOOLTIP_ACCESSIONS_ADD_COLLECTING_SITE": "The place where seeds were collected. It is recommended to name these referencing stable landmarks or features that do not change.",
  "TOOLTIP_ACCESSIONS_ADD_PLANT_ID": "The unique identifier given to a plant for tracking or conservation purposes. Ideally seeds from a plant with a plant ID are kept separate from other plants (not pooled together) in collections and accessions.",
  "TOOLTIP_ACCESSIONS_COLLECTION_SOURCE": "The type of plant population where seeds are collected.",
  "TOOLTIP_ACCESSIONS_HAS_DELIVERIES": "This accession's species cannot be changed because plants from its seeds have been planted at a planting site.",
  "TOOLTIP_ACCESSIONS_ID": "A unique identifier for a seed collection accepted into a seed bank. Any collection from a new species, location, and/or date would typically become a new accession in the seed bank.",
  "TOOLTIP_ACCESSIONS_LOCATION": "Place where seeds are being processed.",
  "TOOLTIP_ACCESSIONS_SUBLOCATION": "Specific area within the place where seeds are being processed.",
  "TOOLTIP_BATCH_NUMBER": "Batch numbers with the format YY-L-N-XXX can be can be broken down as: YY = Year, L = 1 (Seed Bank) / 2 - (Nursery), N = Seed Bank / Nursery number, and XXX = Batch.",
  "TOOLTIP_COMMON_NAME": "The name an organism is known by to the general public, rather than its scientific name.",
  "TOOLTIP_COUNTRY_MY_ACCOUNT": "Your country affects how we display numbers and other information.",
  "TOOLTIP_DASHBOARD_TOTAL_ACTIVE_ACCESSIONS": "This number represents all accessions with the statuses Awaiting Check In, Awaiting Processing, Processing, Drying, and In Storage.",
  "TOOLTIP_ECOSYSTEM_TYPE": "Relatively large units of land or water containing a distinct assemblage of natural communities sharing a large majority of species, dynamics, and environmental conditions.",
  "TOOLTIP_GERMINATING_QUANTITY": "Germinating indicates that seedlings have not yet emerged from seeds. Germinating quantity does not count toward the total quantity.",
  "TOOLTIP_INVENTORY_ADD_ACCESSION_ID": "The ID of the accession used to create this batch.  Unavailable for species that don't have any accessions.",
  "TOOLTIP_NOT_READY_QUANTITY": "What determines a plant as “not ready” is up to your team and is often species specific. For example: size of plant or amount of time acclimated.",
  "TOOLTIP_READY_QUANTITY": "What determines a plant as “ready” is up to your team and is often species specific. For example: size of plant or amount of time acclimated.",
  "TOOLTIP_SCIENTIFIC_NAME": "The binomial Latin name (genus + species) currently accepted in the botanical literature.",
  "TOOLTIP_SPECIES_CONSERVATION_CATEGORY": "IUCN Red List conservation category.",
  "TOOLTIP_SPECIES_FAMILY": "The scientific name of the plant family currently accepted in the botanical literature.",
  "TOOLTIP_SPECIES_GROWTH_FORM": "A structural category consisting of individuals or species of the same general habit of growth but not necessarily related.",
  "TOOLTIP_SPECIES_RARE": "Species with limited wild population sizes, often found in isolated geographical locations; may meet criteria for endangered or threatened status but have not yet been legally listed or assessed.",
  "TOOLTIP_SPECIES_SEED_STORAGE_BEHAVIOR": "The capacity of seeds to survive desiccation and temperatures to levels necessary for ex site (off site) storage.",
  "TOOLTIP_TIME_ZONE_MY_ACCOUNT": "We use time zones to display notifications in your local time. Select the time zone that applies to you.",
  "TOOLTIP_TIME_ZONE_NURSERY": "We use time zones for notifications and to determine the correct date for your region. Select the time zone that applies to this nursery. All work done in this nursery will use this time zone.",
  "TOOLTIP_TIME_ZONE_ORGANIZATION": "We use time zones for notifications and to determine the correct date for your region. Select the time zone that applies to your organization as a whole. You can select time zones for your seed banks, nurseries, and planting sites in each of their settings pages.",
  "TOOLTIP_TIME_ZONE_PLANTING_SITE": "We use time zones for notifications and to determine the correct date for your region. Select the time zone that applies to this specific planting site. All work done in this planting site will use this time zone.",
  "TOOLTIP_TIME_ZONE_SEEDBANK": "We use time zones for notifications and to determine the correct date for your region. Select the time zone that applies to this seed bank. All work done in this seed bank will use this time zone.",
  "TOOLTIP_TOTAL_QUANTITY": "Total quantity is the sum of the not ready and ready quantities.",
  "TOOLTIP_TOTAL_WITHDRAWN": "The total number of plants withdrawn for any purpose.",
  "TOOLTIP_VIABILITY_TEST_AGAR_PETRI_DISH": "A dish that contains a growth medium of solidified agar.",
  "TOOLTIP_VIABILITY_TEST_CHEMICAL": "Treating seeds with a plant growth hormone or other chemical to break physiological dormancy.",
  "TOOLTIP_VIABILITY_TEST_FRESH": "Seeds which were recently collected and have not been stored in the seed bank; recommended to establish a baseline of viability for a new accession.",
  "TOOLTIP_VIABILITY_TEST_MEDIA_MIX": "A mix of substances through which roots grow and extract water and nutrients; may contain any of the media below.",
  "TOOLTIP_VIABILITY_TEST_MOSS": "A small non-flowering, non-vascular plant which can be sterilized and used as a growth medium with high moisture retaining capacity.",
  "TOOLTIP_VIABILITY_TEST_NURSERY_MEDIA": "A substance through which roots grow and extract water and nutrients in a pot, tray, or other nursery container.",
  "TOOLTIP_VIABILITY_TEST_PAPER_PETRI_DISH": "A dish that contains a growth medium of germination paper.",
  "TOOLTIP_VIABILITY_TEST_PERLITE_VERMICULITE": "Lightweight sand substitutes for soilless potting mixes which are often used to improve aeration and texture in potting soil and garden soil mixtures.",
  "TOOLTIP_VIABILITY_TEST_SAND": "A loose granular substance resulting from the erosion of siliceous and other rocks and forming a major constituent of beaches, riverbeds, the seabed, and deserts.",
  "TOOLTIP_VIABILITY_TEST_SAND_PETRI_DISH": "A dish that contains a growth medium of sand.",
  "TOOLTIP_VIABILITY_TEST_SCARIFY": "Weakening, opening, or otherwise altering the seed coat to make it permeable to water, to break physical dormancy.",
  "TOOLTIP_VIABILITY_TEST_SEED_TYPE": "Condition of seeds to be tested for viability.",
  "TOOLTIP_VIABILITY_TEST_SOAK": "A process of imbibing a seed by immersing the seed in water, to break physical dormancy.",
  "TOOLTIP_VIABILITY_TEST_SOIL": "A black or dark brown material typically consisting of a mixture of organic remains, clay, and rock particles.",
  "TOOLTIP_VIABILITY_TEST_STORED": "Seeds which have been stored for any length of time; recommended to monitor viability over time in order to use seeds before viability is lost in storage.",
  "TOOLTIP_VIABILITY_TEST_STRATIFICATION": "A process of exposing seeds to alternating temperatures, simulating natural conditions that seeds would experience, to break physiological dormancy.",
  "TOOLTIP_VIABILITY_TEST_SUBSTRATE": "The surface or material that an organism lives, grows, or obtains its nourishment from.",
  "TOOLTIP_VIABILITY_TEST_TREATMENT": "The biological, physical and chemical agents and techniques used to break dormancy and/or speed germination.",
  "TOTAL": "Total",
  "TOTAL_ACTIVE_ACCESSIONS": "Total Active Accessions",
  "TOTAL_AVERAGE_SCORE": "Total Average Score",
  "TOTAL_CARBON_T": "Total Carbon (t)",
  "TOTAL_EXPANSION_POTENTIAL": "Total Expansion Potential (ha)",
  "TOTAL_HECTARES_PLANTED": "Total Hectares Planted",
  "TOTAL_HECTARES_PLANTED_TOOLTIP": "This is the total number of hectares marked as “Planting Complete” in this Planting Site",
  "TOTAL_NUMBER_OF_PLANTS": "Total Number of Plants",
  "TOTAL_NUMBER_OF_PLANTS_PROPAGATED": "Total Number of Plants Propagated",
  "TOTAL_NUMBER_OF_PLANTS_PROPAGATED_FOR_PROJECT": "Plants Propagated for {0}",
  "TOTAL_PLANTED": "Total Planted",
  "TOTAL_PLANTED_AREA_HA": "Total Planted Area (Ha) *",
  "TOTAL_PLANTED_REQUIRED": "Total Planted *",
  "TOTAL_PLANTING_AREA": "Total Planting Area",
  "TOTAL_PLANTING_SITE_AREA_HA": "Total Planting Site Area (Ha) *",
  "TOTAL_PLANTS_AND_SPECIES": "Total Plants and Species",
  "TOTAL_PLANTS_OBSERVED": "Total Plants Observed",
  "TOTAL_PLANTS_PLANTED": "Total Plants Planted",
  "TOTAL_PLANTS_PLANTED_HELPER_TEXT": "Species not classified as “trees” in the species list.",
  "TOTAL_PLANTS_PLANTED_REQUIRED": "Total Plants Planted *",
  "TOTAL_PLANTS_PLANTED_TOOLTIP": "Total plants planted is the total number of plants reported as planted as of the latest withdrawal.",
  "TOTAL_QUANTITY": "Total Quantity",
  "TOTAL_QUANTITY_MOVED": "Total Quantity Moved",
  "TOTAL_READY_QUANTITY": "Total Ready Quantity",
  "TOTAL_SEED_COUNT": "Total Seed Count",
  "TOTAL_SEEDLINGS_COUNT": "Total Seedlings Count",
  "TOTAL_SEEDLINGS_SENT": "Total Seedlings Sent",
  "TOTAL_SEEDS_GERMINATED": "Total Seeds Germinated",
  "TOTAL_SEEDS_GERMINATED_ERROR": "Germinated amount should not be more than tested amount.",
  "TOTAL_SEEDS_STORED": "Total Number of Seeds Stored",
  "TOTAL_SEEDS_STORED_FOR_PROJECT": "Seeds Stored for {0}",
  "TOTAL_SEEDS_TESTED": "Total Seeds Tested",
  "TOTAL_SEEDS_TESTED_ERROR": "Seeds tested should not be more than remaining seeds",
  "TOTAL_SPECIES": "Total Species",
  "TOTAL_SPECIES_PLANTED": "Total Species Planted",
  "TOTAL_SPECIES_PLANTED_TOOLTIP": "Total species planted is the total number of species reported as planted as of the latest withdrawal.",
  "TOTAL_TREES_PLANTED": "Total Trees Planted *",
  "TOTAL_TREES_PLANTED_HELPER_TEXT": "Species classified as “trees” in the species list.",
  "TOTAL_WEIGHT": "Total Weight",
  "TOTAL_WITHDRAW": "Total Withdraw",
  "TOTAL_WITHDRAWN": "Total Withdrawn",
  "TOTAL_WITHDRAWN_COUNT": "Total Withdrawn (seeds)",
  "TOTAL_WITHDRAWN_FOR_PLANTING": "Total Withdrawn for Planting",
  "TOTAL_WITHDRAWN_WEIGHT_GRAMS": "Total Withdrawn (g)",
  "TOTAL_WITHDRAWN_WEIGHT_KILOGRAMS": "Total Withdrawn (kg)",
  "TOTAL_WITHDRAWN_WEIGHT_MILLIGRAMS": "Total Withdrawn (mg)",
  "TOTAL_WITHDRAWN_WEIGHT_OUNCES": "Total Withdrawn (oz)",
  "TOTAL_WITHDRAWN_WEIGHT_POUNDS": "Total Withdrawn (lb)",
  "TREATMENT": "Treatment",
  "TREATMENT_AFTER": "Treatement (After)",
  "TREATMENT_BEFORE": "Treatment (Before)",
  "TREE": "Tree",
  "TREES_AND_SHRUBS": "Trees and Shrubs",
  "TREES_OR_SHRUBS": "Trees or Shrubs",
  "TREES_TRUNKS": "Trees/Trunks",
  "TRUNCATED_TEXT_MORE_LINK": "more",
  "TRY_AGAIN": "Try Again",
  "TUTORIAL_PREFIX": "Tutorial: {0}",
  "TWENTY_FIVE_TO_FIFTY_PERCENT": "25% to 50%",
  "TYPE": "Type",
  "TYPE_ELLIPSIS": "Type...",
  "TYPE_OF_FOREST": "Type of Forest",
  "UNABLE_TO_ADD_PERSON": "Unable to Add Person",
  "UNABLE_TO_CONNECT_TO_SENSOR_KIT": "We were unable to connect to your sensor kit. Sometimes this is because it is not connected to power or internet. Please email {0} so we can assist you.",
  "UNABLE_TO_LOAD_NOTIFICATIONS": "Unable to load notifications. Try again later.",
  "UNASSIGNED": "Unassigned",
  "UNCLAIMED": "Unclaimed",
  "UNDERPERFORMANCE_DESCRIPTION": "Provide information for underperformance.",
  "UNDERPERFORMANCE_JUSTIFICATION": "Underperformance Justification",
  "UNDO": "Undo",
  "UNDO_PLANTING_COMPLETE": "Undo Planting Complete",
  "UNDO_WITHDRAWAL": "Undo Withdrawal",
  "UNDO_WITHDRAWAL_CONFIRMATION": "Are you sure you want to undo this withdrawal?",
  "UNDONE_WITHDRAWAL_MESSAGE": "This withdrawal was undone and the quantities were restored to the original batch.",
  "UNEXPECTED_ERROR": "An unexpected error occurred.",
  "UNFAVORABLE_WEATHER": "Unfavorable Weather",
  "UNITS": "Units",
  "UNKNOWN": "Unknown",
  "UNLIKELY": "Unlikely",
  "UNRECOGNIZED_SPECIES": "Unrecognized Species",
  "UNRECOGNIZED_SPECIES_MESSAGE": "Match the following entries to species that are already in Terraware:",
  "UNSPECIFIED": "Unspecified",
  "UPCOMING": "Upcoming",
  "UPCOMING_PLANTING_SEASONS": "Upcoming Planting Seasons",
  "UPDATE": "Update",
  "UPDATE_NEEDED": "Update Needed",
  "UPDATE_REQUESTED": "Update Requested",
  "UPDATE_STATUS_WARNING": "You‘re about to update the status",
  "UPLOAD": "Upload",
  "UPLOAD_A_MAP_OF_THE_PROJECT_BOUNDARY": "Upload a Map of the Project Boundary",
  "UPLOAD_CSV_FILE": "Upload CSV File",
  "UPLOAD_DELIVERABLES": "Upload Deliverables",
  "UPLOAD_DELIVERABLES_MESSAGE": "Deliverables must reference existing module IDs. Make sure the modules being referenced by deliverables are uploaded first.",
  "UPLOAD_ELLIPSIS": "Upload...",
  "UPLOAD_FAILED": "Upload Failed",
  "UPLOAD_FILE": "Upload File",
  "UPLOAD_FILES_DESCRIPTION": "Browse or drag and drop files.",
  "UPLOAD_FILES_TITLE": "Upload File(s)",
  "UPLOAD_MODULES_DESCRIPTION": "Browse or drag and drop a CSV file.",
  "UPLOAD_PHOTO": "Upload Photo...",
  "UPLOAD_PHOTO_DESCRIPTION": "Browse or drag and drop a file (JPG, PNG).",
  "UPLOAD_PHOTO_MOBILE_DESCRIPTION": "Browse files (JPG, PNG).",
  "UPLOAD_PHOTOS": "Upload Photo(s)",
  "UPLOAD_SHAPEFILE": "Upload Shapefile",
  "UPLOAD_SHAPEFILE_DESCRIPTION": "Upload File\n(file type examples: GeoJSON, kml/kmz)",
  "UPLOAD_SPATIAL_FILES": "Upload spatial file(s)",
  "USE_ORGANIZATION_TIME_ZONE": "Use organization's time zone",
  "USED_UP": "Used Up",
  "USER_NOTIFICATION_ACTION": "To change your preferences, go to [My Account]",
  "USER_NOTIFICATION_ACTION_SETTINGS": "To change your preferences, go to [Settings]",
  "USER_WITH_EMAIL_DOES_NOT_EXIST": "User with this email does not exist",
  "VALUE": "Value",
  "VALUE_CANT_EXCEED_100": "Value can’t exceed 100%",
  "VALUES_ALIGNMENT": "Values Alignment",
  "VARIABLE_DETAILS": "Variable Details",
  "VARIABLE_ERROR_NUMBER_DECIMAL_PLACES": "The value has exceeded the maximum decimal places of {0}",
  "VARIABLE_ERROR_NUMBER_MAX_LIMIT": "The value is above the maximum value of {0}",
  "VARIABLE_ERROR_NUMBER_MIN_LIMIT": "The value is below the minimum value of {0}",
  "VARIABLE_ERROR_NUMBER_NAN": "The value is not a number",
  "VARIABLE_HISTORY": "Variable History",
  "VARIABLE_STATUS": "Variable Status",
  "VARIABLES": "Variables",
  "VCS_TEMPLATE_NAME": "VCS Project Description Template, v4.3",
  "VERRA_NPRT": "Verra Non-Permanence Risk Tool (NPRT)",
  "VERSION": "Version",
  "VERSION_NAME": "Version Name",
  "VERSION_PREVIEW": "Version Preview",
  "VERSIONS": "Versions",
  "VIABILITY": "Viability",
  "VIABILITY_RATE": "Viability Rate",
  "VIABILITY_RESULT": "Viability Result",
  "VIABILITY_TEST": "Viability Test",
  "VIABILITY_TEST_NUMBER": "Viability Test (#{0})",
  "VIABILITY_TEST_START_DATE_ERROR": "This should not be before the date when seeds were collected",
  "VIABILITY_TESTING": "Viability Testing",
  "VIABILITY_TESTING_EMPTY_MESSAGE": "Viability Testing helps you track seed quality. You can conduct a nursery or lab germination test, or perform a cut test.",
  "VIABILITY_TESTS": "Viability Tests",
  "VIEW": "View",
  "VIEW_ALL_DELIVERABLES": "View All Deliverables",
  "VIEW_APPLICATION": "View Application",
  "VIEW_DELIVERABLES": "View Deliverables",
  "VIEW_FULL_DASHBOARD": "View Full Dashboard",
  "VIEW_HISTORY": "View History",
  "VIEW_LESS": "View Less",
  "VIEW_MAP": "View Map",
  "VIEW_MORE": "View More",
  "VIEW_PLANTING_PROGRESS": "View Planting Progress",
  "VIEW_PRESCREEN_SUBMISSION": "View Pre-screen Submission",
  "VIEW_REPORTS": "View Reports",
  "VIEW_SESSION": "View Session",
  "VIEW_SITES_ZONES_SUBZONES": "View Sites, Zones, and Subzones on a map.",
  "VIEW_SPECIES_LIST": "View Species List",
  "VINE": "Vine",
  "VOTER": "Voter: {0}",
  "VOTING_DECISION": "Voting Decision",
  "WAITING_TO_DOWNLOAD": "Waiting to download...",
  "WAITLIST": "Waitlist",
  "WATER_DEPTH_M": "Water Depth (m)",
  "WATTS_VALUE": "{0}W",
  "WEIGHT": "Weight",
  "WEIGHT_GRAMS": "Weight (g)",
  "WEIGHT_KILOGRAMS": "Weight (kg)",
  "WEIGHT_MILLIGRAMS": "Weight (mg)",
  "WEIGHT_OUNCES": "Weight (oz)",
  "WEIGHT_POUNDS": "Weight (lb)",
  "WEIGHT_SYSTEM_SELECTED": "Weight system: {0}",
  "WELCOME": "Welcome!",
  "WELCOME_MSG": "Welcome and happy seeding!",
  "WELCOME_PERSON": "Welcome, {0}!",
  "WELCOME_TO_TERRAWARE_PERSON": "Welcome to Terraware, {0}!",
  "WHAT_NEEDS_TO_BE_TRUE": "What Needs To Be True",
  "WILD": "Wild",
  "WILD_IN_SITU": "Wild (In Situ)",
  "WILD_IN_SITU_DESCRIPTION": "Plants that occur naturally in wild areas and were not planted by people.",
  "WITHDRAW": "Withdraw",
  "WITHDRAW_ALL": "Withdraw all",
  "WITHDRAW_BY": "Withdraw By",
  "WITHDRAW_DATE_REQUIRED": "Withdraw Date *",
  "WITHDRAW_FROM_BATCHES": "Withdraw from Batches",
  "WITHDRAW_INSTRUCTIONS": "Select a withdrawal purpose and enter the quantities from each batch to withdraw.",
  "WITHDRAW_QUANTITY": "Withdraw Quantity",
  "WITHDRAW_QUANTITY_REQUIRED": "Withdraw Quantity *",
  "WITHDRAW_SEEDS": "Withdraw Seeds",
  "WITHDRAW_SINGLE_NURSERY": "You may only bulk withdraw from one nursery at a time.",
  "WITHDRAWAL": "Withdrawal",
  "WITHDRAWAL_BATCHES_MISSING_QUANTITY_ERROR": "Enter a quantity in at least one seedlings batch row.",
  "WITHDRAWAL_DETAILS": "Withdrawal Details",
  "WITHDRAWAL_HISTORY": "Withdrawal History",
  "WITHDRAWAL_UNDONE": "Withdrawal Undone",
  "WITHDRAWAL_UNDONE_DESCRIPTION": "Withdraw was undone and the quantities were restored to the original batch.",
  "WITHDRAWALS": "Withdrawals",
  "WITHDRAWN": "Withdrawn",
  "WITHDRAWN_BY": "Withdrawn By",
  "WITHDRAWN_DATE": "Withdrawn Date",
  "WITHDRAWN_QUANTITY_ERROR": "Exceeds remaining quantity",
  "WITHDRAWN_QUANTITY_GREATER_THAN_ZERO_ERROR": "Withdrawn Quantity Must Be Greater Than 0",
  "WITHOUT_MAP": "Without Map",
  "WOOD_DENSITY_LEVEL": "Wood Density Level",
  "WORDS": "Words",
  "WORKERS_PAID_ENGAGED": "Total Number of Paid Workers Engaged *",
  "WORKERS_PAID_FEMALE": "Female Paid Workers *",
  "WORKERS_VOLUNTEERS": "Volunteers *",
  "WORKSHOP": "Workshop",
  "WORKSHOPS": "Workshops",
  "X_HA": "{0} ha",
  "X_HA_IN_TOTAL_PLANTING_AREA": " {0} ha in Total Planting Area",
  "X_HA_TOTAL_IN_PLANTING_SITE": " {0} ha Total in Planting Site",
  "X_HECTARES": "{0} hectares",
  "YEAR": "Year",
  "YES": "Yes",
  "YOU_APPROVED_SPECIES": "You approved {0}.",
  "YOU_ARE_ABOUT_TO_APPROVE_THIS_DELIVERABLE": "You are about to approve this deliverable.",
  "YOU_ARE_ABOUT_TO_APPROVE_THIS_QUESTIONS_DELIVERABLE": "You are about to approve this Questionnaire Deliverable. This will approve the list as a deliverable and will not affect individual variable statuses.",
  "YOU_ARE_ABOUT_TO_APPROVE_THIS_REPORT": "You are about to approve this Report.",
  "YOU_ARE_ABOUT_TO_APPROVE_THIS_SPECIES": "You are about to approve this Species.",
  "YOU_ARE_ABOUT_TO_APPROVE_THIS_SPECIES_DELIVERABLE": "You are about to approve this Species List. This will approve the list as a deliverable and will not affect individual species statuses.",
  "YOU_ARE_ABOUT_TO_PUBLISH": "You are about to publish to the Funder Portal.",
  "YOU_ARE_ABOUT_TO_SUBMIT_THIS_SPECIES_DELIVERABLE": "Are you sure you want to submit this species list for approval?",
  "YOU_ARE_HERE": "You are here",
  "YOUR_APPLICATIONS": "Your Applications",
  "ZERO": "zero",
  "ZONE": "Zone",
  "ZONE_BOUNDARIES": "Zone Boundaries",
  "ZONE_GEOMETRY_CHANGED": "Geometry for {0} changed on {1}",
  "ZONE_LEVEL_DATA": "Zone Level Data",
  "ZONE_LEVEL_DATA_MAP_TITLE": "What does the planting site look like based on what we reported to have planted?",
  "ZONE_LEVEL_DATA_MAP_TITLE_WITH_OBSERVATION": "What does the planting site look like as of {0}?",
  "ZONE_MORTALITY": "Zone Mortality",
  "ZONE_MORTALITY_TOOLTIP": "Zone Mortality shows the zones with the highest and lowest mortality rates, among the zones that were observed.",
  "ZONE_NAME_IN_USE": "Zone name is already in use.",
  "ZONE_NAME_MAXIMUM_LENGTH": "Zone name should be 15 characters or less.",
  "ZONE_REQUIRED": "Zone *",
  "ZONE_TRENDS": "Zone Trends",
  "ZONES": "Zones"
};
